// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AllowsInterestPolicyListData, AllowsInterestPolicyListErrors, AllowsInterestPolicyListResponses, AndroidCallbackData, AndroidCallbackErrors, AndroidCallbackResponses, BestContentsFeedbackData, BestContentsFeedbackErrors, BestContentsFeedbackResponses, CalculateDonationData, CalculateDonationErrors, CalculateDonationResponses, Callback1Data, Callback1Errors, Callback1Responses, CallbackCompleteData, CallbackCompleteErrors, CallbackCompleteResponses, CallbackData, CallbackErrors, CallbackResponses, CheckPlusSuccessData, CheckPlusSuccessErrors, CheckPlusSuccessResponses, CommonCodeInit1Data, CommonCodeInit1Errors, CommonCodeInit1Responses, CommonCodeInitData, CommonCodeInitErrors, CommonCodeInitResponses, CompleteData, CompleteErrors, CompleteResponses, CompleteSignupData, CompleteSignupErrors, CompleteSignupResponses, CreateApiCounselData, CreateApiCounselErrors, CreateApiCounselResponses, CreateLoginTokenData, CreateLoginTokenErrors, CreateLoginTokenResponses, FaqListData, FaqListErrors, FaqListResponses, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsErrors, FeedbackCommunityWelloNewsResponses, FeedbackPointMarketProductData, FeedbackPointMarketProductErrors, FeedbackPointMarketProductResponses, FileDecryptionDownloadData, FileDecryptionDownloadErrors, FileDecryptionDownloadResponses, FileDeleteData, FileDeleteErrors, FileDeleteResponses, FileUploadData, FileUploadErrors, FileUploadResponses, FindAllInquiriesData, FindAllInquiriesErrors, FindAllInquiriesResponses, FindArticleData, FindArticleErrors, FindArticleFeedbackData, FindArticleFeedbackErrors, FindArticleFeedbackResponses, FindArticleResponses, FindBenefitLotteryPoolData, FindBenefitLotteryPoolErrors, FindBenefitLotteryPoolResponses, FindBenefitMenuListData, FindBenefitMenuListErrors, FindBenefitMenuListResponses, FindBestContentsData, FindBestContentsErrors, FindBestContentsResponses, FindBestContentsTagListData, FindBestContentsTagListErrors, FindBestContentsTagListResponses, FindChildHomeLoveGovCodeListData, FindChildHomeLoveGovCodeListErrors, FindChildHomeLoveGovCodeListResponses, FindDailyPickListData, FindDailyPickListErrors, FindDailyPickListResponses, FindDaouProductListData, FindDaouProductListErrors, FindDaouProductListResponses, FindDonationBusinessesData, FindDonationBusinessesErrors, FindDonationBusinessesResponses, FindEventRewardListData, FindEventRewardListErrors, FindEventRewardListResponses, FindFeaturedDonationBusinessListData, FindFeaturedDonationBusinessListErrors, FindFeaturedDonationBusinessListResponses, FindFeedsData, FindFeedsErrors, FindFeedsResponses, FindGeneralDownloadableCouponsData, FindGeneralDownloadableCouponsErrors, FindGeneralDownloadableCouponsResponses, FindGiftCategoryGroupListData, FindGiftCategoryGroupListErrors, FindGiftCategoryGroupListResponses, FindGiftCategoryGroupProductListData, FindGiftCategoryGroupProductListErrors, FindGiftCategoryGroupProductListResponses, FindGiftCategoryListData, FindGiftCategoryListErrors, FindGiftCategoryListResponses, FindGiftProductDetailData, FindGiftProductDetailErrors, FindGiftProductDetailResponses, FindGiftProductListData, FindGiftProductListErrors, FindGiftProductListResponses, FindGiftProductsData, FindGiftProductsErrors, FindGiftProductsResponses, FindGoodPointTypesData, FindGoodPointTypesErrors, FindGoodPointTypesResponses, FindHomeInstitutionListData, FindHomeInstitutionListErrors, FindHomeInstitutionListResponses, FindHomeInstitutionSpecialtyListData, FindHomeInstitutionSpecialtyListErrors, FindHomeInstitutionSpecialtyListResponses, FindHomeLoveGovCodeGroupChildListData, FindHomeLoveGovCodeGroupChildListErrors, FindHomeLoveGovCodeGroupChildListResponses, FindHomeLoveGovCodeGroupListData, FindHomeLoveGovCodeGroupListErrors, FindHomeLoveGovCodeGroupListResponses, FindHometownNewsData, FindHometownNewsErrors, FindHometownNewsResponses, FindInquiryData, FindInquiryErrors, FindInquiryResponses, FindIntegratedData, FindIntegratedErrors, FindIntegratedResponses, FindLocalMarketProductsData, FindLocalMarketProductsErrors, FindLocalMarketProductsResponses, FindMonthlyThemesData, FindMonthlyThemesErrors, FindMonthlyThemesResponses, FindNonsanRouletteData, FindNonsanRouletteErrors, FindNonsanRouletteResponses, FindParentHomeLoveGovCodeListData, FindParentHomeLoveGovCodeListErrors, FindParentHomeLoveGovCodeListResponses, FindPhotoReviewsData, FindPhotoReviewsErrors, FindPhotoReviewsResponses, FindPoliciesData, FindPoliciesErrors, FindPoliciesResponses, FindPopularGiftProductListData, FindPopularGiftProductListErrors, FindPopularGiftProductListResponses, FindQueryAgeCodeData, FindQueryAgeCodeErrors, FindQueryAgeCodeResponses, FindQueryJobCodeData, FindQueryJobCodeErrors, FindQueryJobCodeResponses, FindQueryProvisionCodeData, FindQueryProvisionCodeErrors, FindQueryProvisionCodeResponses, FindQueryTargetCodeData, FindQueryTargetCodeErrors, FindQueryTargetCodeResponses, FindRecentGiftProductListData, FindRecentGiftProductListErrors, FindRecentGiftProductListResponses, FindRecommendGiftProductData, FindRecommendGiftProductErrors, FindRecommendGiftProductResponses, FindRelatedGiftProductListData, FindRelatedGiftProductListErrors, FindRelatedGiftProductListResponses, FindReviewData, FindReviewErrors, FindReviewResponses, FindReviewsData, FindReviewsErrors, FindReviewsResponses, FindRootGiftCategoryListData, FindRootGiftCategoryListErrors, FindRootGiftCategoryListResponses, FindThemeArticlesData, FindThemeArticlesErrors, FindThemeArticlesResponses, FindThemeFestivalsData, FindThemeFestivalsErrors, FindThemeFestivalsResponses, FindTourDistanceData, FindTourDistanceErrors, FindTourDistanceResponses, FindTourFeedbackData, FindTourFeedbackErrors, FindTourFeedbackResponses, FindTourFestivalData, FindTourFestivalErrors, FindTourFestivalResponses, FindTourFestivalsData, FindTourFestivalsErrors, FindTourFestivalsResponses, FindTourLclsSystmCodeListData, FindTourLclsSystmCodeListErrors, FindTourLclsSystmCodeListResponses, FindTourReviewsData, FindTourReviewsErrors, FindTourReviewsResponses, FindTrendData, FindTrendErrors, FindTrendResponses, FindWeeklyBestPhotoReviewListData, FindWeeklyBestPhotoReviewListErrors, FindWeeklyBestPhotoReviewListResponses, GetActiveMaintenanceListData, GetActiveMaintenanceListErrors, GetActiveMaintenanceListResponses, GetAdminHomeSearchKeywordListData, GetAdminHomeSearchKeywordListErrors, GetAdminHomeSearchKeywordListResponses, GetApiPolicyListData, GetApiPolicyListErrors, GetApiPolicyListResponses, GetApiPolicyNameListData, GetApiPolicyNameListErrors, GetApiPolicyNameListResponses, GetApiProductNameListData, GetApiProductNameListErrors, GetApiProductNameListResponses, GetApiThemeData, GetApiThemeErrors, GetApiThemeKeywordNameListData, GetApiThemeKeywordNameListErrors, GetApiThemeKeywordNameListResponses, GetApiThemeListData, GetApiThemeListErrors, GetApiThemeListResponses, GetApiThemeNameListData, GetApiThemeNameListErrors, GetApiThemeNameListResponses, GetApiThemeResponses, GetBestContentsData, GetBestContentsErrors, GetBestContentsResponses, GetCommunityWelloNewsData, GetCommunityWelloNewsErrors, GetCommunityWelloNewsListData, GetCommunityWelloNewsListErrors, GetCommunityWelloNewsListResponses, GetCommunityWelloNewsResponses, GetControlManagementsData, GetControlManagementsErrors, GetControlManagementsResponses, GetDecemberEventGiftProductListData, GetDecemberEventGiftProductListErrors, GetDecemberEventGiftProductListResponses, GetDecemberInstitutionEventInfoListData, GetDecemberInstitutionEventInfoListErrors, GetDecemberInstitutionEventInfoListResponses, GetDecemberRandomTicketWinnerListData, GetDecemberRandomTicketWinnerListErrors, GetDecemberRandomTicketWinnerListResponses, GetDonationBusinessCommentListData, GetDonationBusinessCommentListErrors, GetDonationBusinessCommentListResponses, GetDonationBusinessData, GetDonationBusinessDetailCountData, GetDonationBusinessDetailCountErrors, GetDonationBusinessDetailCountResponses, GetDonationBusinessErrors, GetDonationBusinessListData, GetDonationBusinessListErrors, GetDonationBusinessListResponses, GetDonationBusinessResponses, GetEmergencyRoomCodeListData, GetEmergencyRoomCodeListErrors, GetEmergencyRoomCodeListResponses, GetEmergencyRoomData, GetEmergencyRoomErrors, GetEmergencyRoomListCountData, GetEmergencyRoomListCountErrors, GetEmergencyRoomListCountResponses, GetEmergencyRoomListData, GetEmergencyRoomListErrors, GetEmergencyRoomListResponses, GetEmergencyRoomLiveData, GetEmergencyRoomLiveErrors, GetEmergencyRoomLiveResponses, GetEmergencyRoomRegionListData, GetEmergencyRoomRegionListErrors, GetEmergencyRoomRegionListResponses, GetEmergencyRoomResponses, GetEventAmountInfoData, GetEventAmountInfoErrors, GetEventAmountInfoResponses, GetGiftOrderProductPhotoReviewListByProductData, GetGiftOrderProductPhotoReviewListByProductErrors, GetGiftOrderProductPhotoReviewListByProductResponses, GetGiftOrderProductReviewData, GetGiftOrderProductReviewErrors, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListErrors, GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewResponses, GetGiftProductSeoData, GetGiftProductSeoErrors, GetGiftProductSeoResponses, GetGiftReviewFeedData, GetGiftReviewFeedErrors, GetGiftReviewFeedResponses, GetHomeDonationEventData, GetHomeDonationEventErrors, GetHomeDonationEventResponses, GetHomeDonationHistoryByDonationBusinessListData, GetHomeDonationHistoryByDonationBusinessListErrors, GetHomeDonationHistoryByDonationBusinessListResponses, GetHomeDonationStatisticsListData, GetHomeDonationStatisticsListErrors, GetHomeDonationStatisticsListResponses, GetHomeInquiryData, GetHomeInquiryErrors, GetHomeInquiryListData, GetHomeInquiryListErrors, GetHomeInquiryListResponses, GetHomeInquiryResponses, GetHomeInstitutionBenefitListAllData, GetHomeInstitutionBenefitListAllErrors, GetHomeInstitutionBenefitListAllResponses, GetHomeInstitutionBenefitListData, GetHomeInstitutionBenefitListErrors, GetHomeInstitutionBenefitListResponses, GetHomeInstitutionBenefitPrivateListData, GetHomeInstitutionBenefitPrivateListErrors, GetHomeInstitutionBenefitPrivateListResponses, GetHomeInstitutionBenefitPublicListData, GetHomeInstitutionBenefitPublicListErrors, GetHomeInstitutionBenefitPublicListResponses, GetHomeInstitutionBenefitRegionListData, GetHomeInstitutionBenefitRegionListErrors, GetHomeInstitutionBenefitRegionListResponses, GetHomeInstitutionContentData, GetHomeInstitutionContentErrors, GetHomeInstitutionContentListData, GetHomeInstitutionContentListErrors, GetHomeInstitutionContentListResponses, GetHomeInstitutionContentResponses, GetHomeInstitutionData, GetHomeInstitutionDonationBusinessData, GetHomeInstitutionDonationBusinessErrors, GetHomeInstitutionDonationBusinessResponses, GetHomeInstitutionErrors, GetHomeInstitutionEventData, GetHomeInstitutionEventErrors, GetHomeInstitutionEventListData, GetHomeInstitutionEventListErrors, GetHomeInstitutionEventListResponses, GetHomeInstitutionEventResponses, GetHomeInstitutionListForSearchFilterData, GetHomeInstitutionListForSearchFilterErrors, GetHomeInstitutionListForSearchFilterResponses, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListErrors, GetHomeInstitutionPolicyListResponses, GetHomeInstitutionResponses, GetHomeLoveGovCodeToIdData, GetHomeLoveGovCodeToIdErrors, GetHomeLoveGovCodeToIdResponses, GetHomeNoticeData, GetHomeNoticeErrors, GetHomeNoticeListData, GetHomeNoticeListErrors, GetHomeNoticeListResponses, GetHomeNoticeResponses, GetHomePopupNoticeData, GetHomePopupNoticeErrors, GetHomePopupNoticeResponses, GetInstitutionGiftProductListData, GetInstitutionGiftProductListErrors, GetInstitutionGiftProductListResponses, GetInstitutionRelatedDonationBusinessData, GetInstitutionRelatedDonationBusinessErrors, GetInstitutionRelatedDonationBusinessResponses, GetInstitutionSpecialtyListData, GetInstitutionSpecialtyListErrors, GetInstitutionSpecialtyListResponses, GetKbMemberLoginTypeList1Data, GetKbMemberLoginTypeList1Errors, GetKbMemberLoginTypeList1Responses, GetKbMemberLoginTypeListData, GetKbMemberLoginTypeListErrors, GetKbMemberLoginTypeListResponses, GetListPolicyCaseCategoryData, GetListPolicyCaseCategoryErrors, GetListPolicyCaseCategoryResponses, GetLiveWelloCommentListData, GetLiveWelloCommentListErrors, GetLiveWelloCommentListResponses, GetMaintenanceData, GetMaintenanceErrors, GetMaintenanceResponses, GetMedianIncomeListData, GetMedianIncomeListErrors, GetMedianIncomeListResponses, GetMemberNameByInviteCodeData, GetMemberNameByInviteCodeErrors, GetMemberNameByInviteCodeResponses, GetMetaPolicyCommentList1Data, GetMetaPolicyCommentList1Errors, GetMetaPolicyCommentList1Responses, GetMetaPolicyCommentListData, GetMetaPolicyCommentListErrors, GetMetaPolicyCommentListResponses, GetNonMemberSuggestPolicyListData, GetNonMemberSuggestPolicyListErrors, GetNonMemberSuggestPolicyListResponses, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListErrors, GetOrderedHomeInstitutionEventListResponses, GetPointMarketProductData, GetPointMarketProductErrors, GetPointMarketProductListByBrandData, GetPointMarketProductListByBrandErrors, GetPointMarketProductListByBrandResponses, GetPointMarketProductListData, GetPointMarketProductListErrors, GetPointMarketProductListResponses, GetPointMarketProductResponses, GetPolicyCodeGeocodingListData, GetPolicyCodeGeocodingListErrors, GetPolicyCodeGeocodingListResponses, GetPolicyDictionaryListData, GetPolicyDictionaryListErrors, GetPolicyDictionaryListResponses, GetProductDetailByProductNumberData, GetProductDetailByProductNumberErrors, GetProductDetailByProductNumberResponses, GetProductDetailData, GetProductDetailErrors, GetProductDetailResponses, GetProductFeedListData, GetProductFeedListErrors, GetProductFeedListResponses, GetProductSeoByProductIdData, GetProductSeoByProductIdErrors, GetProductSeoByProductIdResponses, GetProductSeoData, GetProductSeoErrors, GetProductSeoResponses, GetRecentEventHistoryListData, GetRecentEventHistoryListErrors, GetRecentEventHistoryListInSeptemberData, GetRecentEventHistoryListInSeptemberErrors, GetRecentEventHistoryListInSeptemberResponses, GetRecentEventHistoryListResponses, GetRelatedDonationBusinessData, GetRelatedDonationBusinessErrors, GetRelatedDonationBusinessResponses, GetRelatedHometownNewsListData, GetRelatedHometownNewsListErrors, GetRelatedHometownNewsListResponses, GetTopDonationEventHistoryListData, GetTopDonationEventHistoryListErrors, GetTopDonationEventHistoryListResponses, GetUrlMappingData, GetUrlMappingErrors, GetUrlMappingResponses, GetWelloQuickMenuListData, GetWelloQuickMenuListErrors, GetWelloQuickMenuListResponses, HandleAuthResultData, HandleAuthResultErrors, HandleAuthResultResponses, HandleNicePayWebhookData, HandleNicePayWebhookErrors, HandleNicePayWebhookResponses, HometownNewsData, HometownNewsErrors, HometownNewsFeedbackData, HometownNewsFeedbackErrors, HometownNewsFeedbackResponses, HometownNewsResponses, InitData, InitErrors, InitResponses, IntegrateData, IntegrateErrors, IntegrateResponses, IosCallbackData, IosCallbackErrors, IosCallbackResponses, IsEventInProgressData, IsEventInProgressErrors, IsEventInProgressResponses, JoinEventData, JoinEventErrors, JoinEventResponses, KbWelloPolicyCodeAllListData, KbWelloPolicyCodeAllListErrors, KbWelloPolicyCodeAllListResponses, LoginWelloSnsMember1Data, LoginWelloSnsMember1Errors, LoginWelloSnsMember1Responses, LoginWelloSnsMemberData, LoginWelloSnsMemberErrors, LoginWelloSnsMemberResponses, LoginWelloWithKbPay1Data, LoginWelloWithKbPay1Errors, LoginWelloWithKbPay1Responses, LoginWelloWithKbPayData, LoginWelloWithKbPayErrors, LoginWelloWithKbPayResponses, MessageReceiveData, MessageReceiveErrors, MessageReceiveResponses, MetaCodeAllData, MetaCodeAllErrors, MetaCodeAllResponses, MetaPolicyData, MetaPolicyErrors, MetaPolicyFeedbackData, MetaPolicyFeedbackErrors, MetaPolicyFeedbackResponses, MetaPolicyResponses, NewWelloAppPushCntData, NewWelloAppPushCntErrors, NewWelloAppPushCntResponses, NoticeData, NoticeErrors, NoticeList1Data, NoticeList1Errors, NoticeList1Responses, NoticeListData, NoticeListErrors, NoticeListResponses, NoticeResponses, PopularPolicyListData, PopularPolicyListErrors, PopularPolicyListResponses, RejectMessageData, RejectMessageErrors, RejectMessageResponses, ResignExternalChannelMemberData, ResignExternalChannelMemberErrors, ResignExternalChannelMemberResponses, ResignMembersData, ResignMembersErrors, ResignMembersResponses, ResignWelloWithKbPayData, ResignWelloWithKbPayErrors, ResignWelloWithKbPayResponses, ReverseGeocodingData, ReverseGeocodingErrors, ReverseGeocodingResponses, SaveAllowsWelloDeviceInfoData, SaveAllowsWelloDeviceInfoErrors, SaveAllowsWelloDeviceInfoResponses, SaveNicknameConsentData, SaveNicknameConsentErrors, SaveNicknameConsentResponses, SaveWelloNonmemberRegionData, SaveWelloNonmemberRegionErrors, SaveWelloNonmemberRegionResponses, SaveWelloTrackingData, SaveWelloTrackingErrors, SaveWelloTrackingResponses, SendAppPushData, SendAppPushErrors, SendAppPushResponses, SendExtAppPushData, SendExtAppPushErrors, SendExtAppPushResponses, SnsRefreshToken1Data, SnsRefreshToken1Errors, SnsRefreshToken1Responses, SnsRefreshTokenData, SnsRefreshTokenErrors, SnsRefreshTokenResponses, StartSessionData, StartSessionErrors, StartSessionResponses, StartSignupData, StartSignupErrors, StartSignupResponses, TermData, TermErrors, TermHistoryData, TermHistoryErrors, TermHistoryResponses, TermResponses, UpdateFileTempSaveYnData, UpdateFileTempSaveYnErrors, UpdateFileTempSaveYnResponses, UpdateMessageReceiveData, UpdateMessageReceiveErrors, UpdateMessageReceiveResponses, UpdatePolicyAiInfoData, UpdatePolicyAiInfoErrors, UpdatePolicyAiInfoResponses, UpdateWelloAppPushRead1Data, UpdateWelloAppPushRead1Errors, UpdateWelloAppPushRead1Responses, UpdateWelloAppPushReadData, UpdateWelloAppPushReadErrors, UpdateWelloAppPushReadResponses, VerifyData, VerifyErrors, VerifyResponses, ViewHomeGiftProductData, ViewHomeGiftProductErrors, ViewHomeGiftProductResponses, WelloAppPushListData, WelloAppPushListErrors, WelloAppPushListResponses, WelloBeforeLoginData, WelloBeforeLoginErrors, WelloBeforeLoginResponses, WelloPolicyCodeAllListData, WelloPolicyCodeAllListErrors, WelloPolicyCodeAllListResponses, WelloPolicyCodeBabyListData, WelloPolicyCodeBabyListErrors, WelloPolicyCodeBabyListResponses, WelloPolicyCodeListData, WelloPolicyCodeListErrors, WelloPolicyCodeListResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * 월별 테마 큐레이션 조회
 *
 * 전달받은 날짜의 월에 해당하는 테마 목록과 이전달/다음달 테마 존재 여부를 반환한다.
 */
export const findMonthlyThemes = <ThrowOnError extends boolean = false>(options: Options<FindMonthlyThemesData, ThrowOnError>): RequestResult<FindMonthlyThemesResponses, FindMonthlyThemesErrors, ThrowOnError> => (options.client ?? client).get<FindMonthlyThemesResponses, FindMonthlyThemesErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/monthly', ...options });

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticles = <ThrowOnError extends boolean = false>(options: Options<FindThemeArticlesData, ThrowOnError>): RequestResult<FindThemeArticlesResponses, FindThemeArticlesErrors, ThrowOnError> => (options.client ?? client).get<FindThemeArticlesResponses, FindThemeArticlesErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/{themeId}/article', ...options });

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivals = <ThrowOnError extends boolean = false>(options: Options<FindThemeFestivalsData, ThrowOnError>): RequestResult<FindThemeFestivalsResponses, FindThemeFestivalsErrors, ThrowOnError> => (options.client ?? client).get<FindThemeFestivalsResponses, FindThemeFestivalsErrors, ThrowOnError>({ url: '/wello/v1/allows/theme/{themeId}/festival', ...options });

/**
 * 아티클 상세
 *
 * 아티클 상세 정보와 매핑된 테마 목록을 조회한다.
 */
export const findArticle = <ThrowOnError extends boolean = false>(options: Options<FindArticleData, ThrowOnError>): RequestResult<FindArticleResponses, FindArticleErrors, ThrowOnError> => (options.client ?? client).get<FindArticleResponses, FindArticleErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/article/{articleId}', ...options });

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedback = <ThrowOnError extends boolean = false>(options: Options<FindArticleFeedbackData, ThrowOnError>): RequestResult<FindArticleFeedbackResponses, FindArticleFeedbackErrors, ThrowOnError> => (options.client ?? client).get<FindArticleFeedbackResponses, FindArticleFeedbackErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/article/{articleId}/feedback', ...options });

/**
 * 축제 상세
 *
 * 축제 ID 로 상세 정보를 조회한다. 이미지, 반복정보, 프로그램, 테마 목록을 포함한다.
 */
export const findTourFestival = <ThrowOnError extends boolean = false>(options: Options<FindTourFestivalData, ThrowOnError>): RequestResult<FindTourFestivalResponses, FindTourFestivalErrors, ThrowOnError> => (options.client ?? client).get<FindTourFestivalResponses, FindTourFestivalErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/festival/{tourId}', ...options });

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviews = <ThrowOnError extends boolean = false>(options: Options<FindTourReviewsData, ThrowOnError>): RequestResult<FindTourReviewsResponses, FindTourReviewsErrors, ThrowOnError> => (options.client ?? client).get<FindTourReviewsResponses, FindTourReviewsErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/festival/{tourId}/review', ...options });

/**
 * 분류체계 코드 목록
 *
 * rootCode / parentCode / depth 를 optional AND 필터로 적용하여 분류체계 코드 목록을 조회합니다. 페이징 없음, sort ASC 정렬.
 */
export const findTourLclsSystmCodeList = <ThrowOnError extends boolean = false>(options?: Options<FindTourLclsSystmCodeListData, ThrowOnError>): RequestResult<FindTourLclsSystmCodeListResponses, FindTourLclsSystmCodeListErrors, ThrowOnError> => (options?.client ?? client).get<FindTourLclsSystmCodeListResponses, FindTourLclsSystmCodeListErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/lcls-systm-code', ...options });

/**
 * 좋았어요 항목 타입 목록 조회
 *
 * 투어 리뷰 작성/수정 시 사용 가능한 좋았어요 항목 타입(name, desc) 목록을 조회합니다.
 */
export const findGoodPointTypes = <ThrowOnError extends boolean = false>(options?: Options<FindGoodPointTypesData, ThrowOnError>): RequestResult<FindGoodPointTypesResponses, FindGoodPointTypesErrors, ThrowOnError> => (options?.client ?? client).get<FindGoodPointTypesResponses, FindGoodPointTypesErrors, ThrowOnError>({ url: '/wello/v1/allows/tour/review/good-point-types', ...options });

/**
 * API 도입 문의 작성
 */
export const createApiCounsel = <ThrowOnError extends boolean = false>(options: Options<CreateApiCounselData, ThrowOnError>): RequestResult<CreateApiCounselResponses, CreateApiCounselErrors, ThrowOnError> => (options.client ?? client).post<CreateApiCounselResponses, CreateApiCounselErrors, ThrowOnError>({
    url: '/wello/v2/allows/api-counsel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyListData, ThrowOnError>): RequestResult<GetApiPolicyListResponses, GetApiPolicyListErrors, ThrowOnError> => (options.client ?? client).get<GetApiPolicyListResponses, GetApiPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-policy', ...options });

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiPolicyNameListData, ThrowOnError>): RequestResult<GetApiPolicyNameListResponses, GetApiPolicyNameListErrors, ThrowOnError> => (options.client ?? client).get<GetApiPolicyNameListResponses, GetApiPolicyNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-policy/name', ...options });

/**
 * API 상품명 검색
 */
export const getApiProductNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiProductNameListData, ThrowOnError>): RequestResult<GetApiProductNameListResponses, GetApiProductNameListErrors, ThrowOnError> => (options.client ?? client).get<GetApiProductNameListResponses, GetApiProductNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-product/name', ...options });

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeListData, ThrowOnError>): RequestResult<GetApiThemeListResponses, GetApiThemeListErrors, ThrowOnError> => (options.client ?? client).get<GetApiThemeListResponses, GetApiThemeListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme', ...options });

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeKeywordNameListData, ThrowOnError>): RequestResult<GetApiThemeKeywordNameListResponses, GetApiThemeKeywordNameListErrors, ThrowOnError> => (options.client ?? client).get<GetApiThemeKeywordNameListResponses, GetApiThemeKeywordNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/keyword/name', ...options });

/**
 * API 패키지명 검색
 */
export const getApiThemeNameList = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeNameListData, ThrowOnError>): RequestResult<GetApiThemeNameListResponses, GetApiThemeNameListErrors, ThrowOnError> => (options.client ?? client).get<GetApiThemeNameListResponses, GetApiThemeNameListErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/name', ...options });

/**
 * API 패키지 상품 조회
 */
export const getApiTheme = <ThrowOnError extends boolean = false>(options: Options<GetApiThemeData, ThrowOnError>): RequestResult<GetApiThemeResponses, GetApiThemeErrors, ThrowOnError> => (options.client ?? client).get<GetApiThemeResponses, GetApiThemeErrors, ThrowOnError>({ url: '/wello/v2/allows/api-theme/{apiThemeId}', ...options });

/**
 * 로또 적립금 풀 상태 조회
 *
 * 현재 적립 금액(버림 정수), 목표 금액, 상태(ACCUMULATING/FEVER), 피버 여부, 회차를 반환합니다. 인증 불요.
 */
export const findBenefitLotteryPool = <ThrowOnError extends boolean = false>(options?: Options<FindBenefitLotteryPoolData, ThrowOnError>): RequestResult<FindBenefitLotteryPoolResponses, FindBenefitLotteryPoolErrors, ThrowOnError> => (options?.client ?? client).get<FindBenefitLotteryPoolResponses, FindBenefitLotteryPoolErrors, ThrowOnError>({ url: '/wello/v2/allows/benefit-lottery/pool', ...options });

/**
 * 혜택 메뉴 목록 조회
 *
 * 전시중 혜택 메뉴를 최상위→하위 2단 계층으로 조회합니다. 전시중 하위가 없는 최상위는 제외됩니다.
 */
export const findBenefitMenuList = <ThrowOnError extends boolean = false>(options?: Options<FindBenefitMenuListData, ThrowOnError>): RequestResult<FindBenefitMenuListResponses, FindBenefitMenuListErrors, ThrowOnError> => (options?.client ?? client).get<FindBenefitMenuListResponses, FindBenefitMenuListErrors, ThrowOnError>({ url: '/wello/v2/allows/benefit-menus', ...options });

/**
 * 아티클 태그 목록 조회
 *
 * 아티클 태그 목록 조회 (전시/미삭제, 정렬 순서)
 */
export const findBestContentsTagList = <ThrowOnError extends boolean = false>(options?: Options<FindBestContentsTagListData, ThrowOnError>): RequestResult<FindBestContentsTagListResponses, FindBestContentsTagListErrors, ThrowOnError> => (options?.client ?? client).get<FindBestContentsTagListResponses, FindBestContentsTagListErrors, ThrowOnError>({ url: '/wello/v2/allows/best-contents-tag', ...options });

/**
 * 블록리스트 초기화
 *
 * 블록리스트 추가된 경우 초기화 합니다
 */
export const commonCodeInit1 = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInit1Data, ThrowOnError>): RequestResult<CommonCodeInit1Responses, CommonCodeInit1Errors, ThrowOnError> => (options.client ?? client).post<CommonCodeInit1Responses, CommonCodeInit1Errors, ThrowOnError>({ url: '/wello/v2/allows/blocklist/reset', ...options });

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsList = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsListData, ThrowOnError>): RequestResult<GetCommunityWelloNewsListResponses, GetCommunityWelloNewsListErrors, ThrowOnError> => (options.client ?? client).get<GetCommunityWelloNewsListResponses, GetCommunityWelloNewsListErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news', ...options });

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<FeedbackCommunityWelloNewsData, ThrowOnError>): RequestResult<FeedbackCommunityWelloNewsResponses, FeedbackCommunityWelloNewsErrors, ThrowOnError> => (options.client ?? client).get<FeedbackCommunityWelloNewsResponses, FeedbackCommunityWelloNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news/feedback/{communityIdIdx}', ...options });

/**
 * 커뮤니티 - 웰로 소식 상세
 */
export const getCommunityWelloNews = <ThrowOnError extends boolean = false>(options: Options<GetCommunityWelloNewsData, ThrowOnError>): RequestResult<GetCommunityWelloNewsResponses, GetCommunityWelloNewsErrors, ThrowOnError> => (options.client ?? client).get<GetCommunityWelloNewsResponses, GetCommunityWelloNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/community/wello-news/{communityIdIdx}', ...options });

/**
 * 정책 소식 내 고객정보 조회
 */
export const bestContentsFeedback = <ThrowOnError extends boolean = false>(options: Options<BestContentsFeedbackData, ThrowOnError>): RequestResult<BestContentsFeedbackResponses, BestContentsFeedbackErrors, ThrowOnError> => (options.client ?? client).get<BestContentsFeedbackResponses, BestContentsFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/best/feedback/{bestContentsId}', ...options });

/**
 * 정책 소식 상세 조회
 */
export const getBestContents = <ThrowOnError extends boolean = false>(options: Options<GetBestContentsData, ThrowOnError>): RequestResult<GetBestContentsResponses, GetBestContentsErrors, ThrowOnError> => (options.client ?? client).get<GetBestContentsResponses, GetBestContentsErrors, ThrowOnError>({ url: '/wello/v2/allows/contents/best/{bestContentsIdIdx}', ...options });

/**
 * 현재 제어관리 조회
 */
export const getControlManagements = <ThrowOnError extends boolean = false>(options?: Options<GetControlManagementsData, ThrowOnError>): RequestResult<GetControlManagementsResponses, GetControlManagementsErrors, ThrowOnError> => (options?.client ?? client).get<GetControlManagementsResponses, GetControlManagementsErrors, ThrowOnError>({ url: '/wello/v2/allows/control-managements', ...options });

/**
 * FAQ 목록 조회
 *
 * FAQ 목록을 조회합니다
 */
export const faqList = <ThrowOnError extends boolean = false>(options?: Options<FaqListData, ThrowOnError>): RequestResult<FaqListResponses, FaqListErrors, ThrowOnError> => (options?.client ?? client).get<FaqListResponses, FaqListErrors, ThrowOnError>({ url: '/wello/v2/allows/cs/faq', ...options });

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeList1 = <ThrowOnError extends boolean = false>(options?: Options<NoticeList1Data, ThrowOnError>): RequestResult<NoticeList1Responses, NoticeList1Errors, ThrowOnError> => (options?.client ?? client).get<NoticeList1Responses, NoticeList1Errors, ThrowOnError>({ url: '/wello/v2/allows/cs/notice', ...options });

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const notice = <ThrowOnError extends boolean = false>(options: Options<NoticeData, ThrowOnError>): RequestResult<NoticeResponses, NoticeErrors, ThrowOnError> => (options.client ?? client).get<NoticeResponses, NoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/cs/notice/{noticeId}', ...options });

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomList = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListData, ThrowOnError>): RequestResult<GetEmergencyRoomListResponses, GetEmergencyRoomListErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomListResponses, GetEmergencyRoomListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room', ...options });

/**
 * 응급실 관련 코드 목록 조회
 */
export const getEmergencyRoomCodeList = <ThrowOnError extends boolean = false>(options?: Options<GetEmergencyRoomCodeListData, ThrowOnError>): RequestResult<GetEmergencyRoomCodeListResponses, GetEmergencyRoomCodeListErrors, ThrowOnError> => (options?.client ?? client).get<GetEmergencyRoomCodeListResponses, GetEmergencyRoomCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/code', ...options });

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCount = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomListCountData, ThrowOnError>): RequestResult<GetEmergencyRoomListCountResponses, GetEmergencyRoomListCountErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomListCountResponses, GetEmergencyRoomListCountErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/count', ...options });

/**
 * 응급실 지역별 갯수 조회
 */
export const getEmergencyRoomRegionList = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomRegionListData, ThrowOnError>): RequestResult<GetEmergencyRoomRegionListResponses, GetEmergencyRoomRegionListErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomRegionListResponses, GetEmergencyRoomRegionListErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/region', ...options });

/**
 * 응급실 상세 조회
 */
export const getEmergencyRoom = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomData, ThrowOnError>): RequestResult<GetEmergencyRoomResponses, GetEmergencyRoomErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomResponses, GetEmergencyRoomErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/{emergencyRoomId}', ...options });

/**
 * 응급실 실시간 데이터 조회
 */
export const getEmergencyRoomLive = <ThrowOnError extends boolean = false>(options: Options<GetEmergencyRoomLiveData, ThrowOnError>): RequestResult<GetEmergencyRoomLiveResponses, GetEmergencyRoomLiveErrors, ThrowOnError> => (options.client ?? client).get<GetEmergencyRoomLiveResponses, GetEmergencyRoomLiveErrors, ThrowOnError>({ url: '/wello/v2/allows/emergency-room/{emergencyRoomId}/live', ...options });

/**
 * 애디슨 오퍼월 리워드 콜백
 *
 * Adison 서버가 리워드 지급 시 호출하는 콜백 API. 헤더 X-Hmac-Datetime/X-Hmac-Signature 로 HMAC-SHA256 검증. 요청 바디(JSON): click_key, uid, advertising_id, platform, campaign_id, ad_name, reward, reward_type. 응답은 벤더 raw {"code":200,...}, 실패 시 HTTP 400.
 */
export const callback1 = <ThrowOnError extends boolean = false>(options?: Options<Callback1Data, ThrowOnError>): RequestResult<Callback1Responses, Callback1Errors, ThrowOnError> => (options?.client ?? client).post<Callback1Responses, Callback1Errors, ThrowOnError>({
    url: '/wello/v2/allows/external/adison-offerwall',
    ...options,
    headers: {
        'Content-Type': '*/*',
        ...options?.headers
    }
});

/**
 * 애드팝콘 오퍼월 Android 리워드 콜백
 *
 * IGAWorks에서 Android 리워드 지급 시 호출되는 콜백 API
 */
export const androidCallback = <ThrowOnError extends boolean = false>(options?: Options<AndroidCallbackData, ThrowOnError>): RequestResult<AndroidCallbackResponses, AndroidCallbackErrors, ThrowOnError> => (options?.client ?? client).get<AndroidCallbackResponses, AndroidCallbackErrors, ThrowOnError>({ url: '/wello/v2/allows/external/adpopcorn-offerwall/android/callback', ...options });

/**
 * 애드팝콘 오퍼월 iOS 리워드 콜백
 *
 * IGAWorks에서 iOS 리워드 지급 시 호출되는 콜백 API
 */
export const iosCallback = <ThrowOnError extends boolean = false>(options?: Options<IosCallbackData, ThrowOnError>): RequestResult<IosCallbackResponses, IosCallbackErrors, ThrowOnError> => (options?.client ?? client).get<IosCallbackResponses, IosCallbackErrors, ThrowOnError>({ url: '/wello/v2/allows/external/adpopcorn-offerwall/ios/callback', ...options });

/**
 * 채무자신고 앱푸시 발송 요청(외부)
 *
 * 채무자신고 앱푸시 발송 요청 (외부)
 */
export const sendAppPush = <ThrowOnError extends boolean = false>(options: Options<SendAppPushData, ThrowOnError>): RequestResult<SendAppPushResponses, SendAppPushErrors, ThrowOnError> => (options.client ?? client).post<SendAppPushResponses, SendAppPushErrors, ThrowOnError>({
    url: '/wello/v2/allows/external/kosaf/app-push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * NICE Pay 웹훅 수신
 *
 * NICE Pay 웹훅을 처리합니다.
 */
export const handleNicePayWebhook = <ThrowOnError extends boolean = false>(options: Options<HandleNicePayWebhookData, ThrowOnError>): RequestResult<HandleNicePayWebhookResponses, HandleNicePayWebhookErrors, ThrowOnError> => (options.client ?? client).post<HandleNicePayWebhookResponses, HandleNicePayWebhookErrors, ThrowOnError>({
    url: '/wello/v2/allows/external/local-market/payments/webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 핀크럭스 오퍼월 리워드 콜백
 *
 * 핀크럭스 서버에서 적립금 지급 시 호출되는 콜백 API. 응답은 벤더 규격 raw JSON {"code":"00"}.
 */
export const callback = <ThrowOnError extends boolean = false>(options?: Options<CallbackData, ThrowOnError>): RequestResult<CallbackResponses, CallbackErrors, ThrowOnError> => (options?.client ?? client).post<CallbackResponses, CallbackErrors, ThrowOnError>({ url: '/wello/v2/allows/external/pincrux-offerwall/callback', ...options });

/**
 * 피드 목록 조회
 *
 * 여러 소스의 컨텐츠를 발행일 최신순으로 정렬하여 페이징 조회합니다. (맞춤정책·기부·고향상품·테마는 목록 마지막에 배치)
 */
export const findFeeds = <ThrowOnError extends boolean = false>(options: Options<FindFeedsData, ThrowOnError>): RequestResult<FindFeedsResponses, FindFeedsErrors, ThrowOnError> => (options.client ?? client).post<FindFeedsResponses, FindFeedsErrors, ThrowOnError>({
    url: '/wello/v2/allows/feed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 이벤트 목록 조회
 */
export const getHomeDonationEvent = <ThrowOnError extends boolean = false>(options?: Options<GetHomeDonationEventData, ThrowOnError>): RequestResult<GetHomeDonationEventResponses, GetHomeDonationEventErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeDonationEventResponses, GetHomeDonationEventErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event', ...options });

/**
 * 친구 기부 TOP 목록
 */
export const getTopDonationEventHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetTopDonationEventHistoryListData, ThrowOnError>): RequestResult<GetTopDonationEventHistoryListResponses, GetTopDonationEventHistoryListErrors, ThrowOnError> => (options.client ?? client).get<GetTopDonationEventHistoryListResponses, GetTopDonationEventHistoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/invitee-donation/top', ...options });

/**
 * 초대코드로 회원 이름 조회
 */
export const getMemberNameByInviteCode = <ThrowOnError extends boolean = false>(options: Options<GetMemberNameByInviteCodeData, ThrowOnError>): RequestResult<GetMemberNameByInviteCodeResponses, GetMemberNameByInviteCodeErrors, ThrowOnError> => (options.client ?? client).get<GetMemberNameByInviteCodeResponses, GetMemberNameByInviteCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/member-name', ...options });

/**
 * 최근 포인트 지급 목록
 */
export const getRecentEventHistoryList = <ThrowOnError extends boolean = false>(options: Options<GetRecentEventHistoryListData, ThrowOnError>): RequestResult<GetRecentEventHistoryListResponses, GetRecentEventHistoryListErrors, ThrowOnError> => (options.client ?? client).get<GetRecentEventHistoryListResponses, GetRecentEventHistoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/reward/recent', ...options });

/**
 * 최근 포인트 지급 목록 (9월)
 */
export const getRecentEventHistoryListInSeptember = <ThrowOnError extends boolean = false>(options: Options<GetRecentEventHistoryListInSeptemberData, ThrowOnError>): RequestResult<GetRecentEventHistoryListInSeptemberResponses, GetRecentEventHistoryListInSeptemberErrors, ThrowOnError> => (options.client ?? client).get<GetRecentEventHistoryListInSeptemberResponses, GetRecentEventHistoryListInSeptemberErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event-history/reward/recent/september', ...options });

/**
 * 이벤트 진행 여부
 */
export const isEventInProgress = <ThrowOnError extends boolean = false>(options: Options<IsEventInProgressData, ThrowOnError>): RequestResult<IsEventInProgressResponses, IsEventInProgressErrors, ThrowOnError> => (options.client ?? client).get<IsEventInProgressResponses, IsEventInProgressErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event/is-progressing', ...options });

/**
 * 답례품 기준 참여 가능 이벤트 리워드 목록
 *
 * 해당 답례품으로 참여할 수 있는 기부·후기 이벤트의 지급 리워드를 조회합니다. 카카오뱅크는 상품권 금액(naverPay), 그 밖의 채널은 웰포인트(point)가 채워집니다. 비로그인 경로라 회원의 참여 이력은 보지 않습니다. 논산 룰렛 이벤트는 논산 답례품이고 진행 중(기간 내·경품 미소진)이면 채널과 무관하게 naverPay 30000 으로 포함됩니다(합계 포함, 참여 여부는 보지 않습니다). 순서는 후기 이벤트가 맨 앞이고, 그 뒤로 기부 이벤트와 논산 룰렛이 리워드액 내림차순입니다(금액을 모르는 이벤트는 각 묶음의 맨 뒤).
 */
export const findEventRewardList = <ThrowOnError extends boolean = false>(options: Options<FindEventRewardListData, ThrowOnError>): RequestResult<FindEventRewardListResponses, FindEventRewardListErrors, ThrowOnError> => (options.client ?? client).get<FindEventRewardListResponses, FindEventRewardListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-event/reward', ...options });

/**
 * 기부금 계산
 */
export const calculateDonation = <ThrowOnError extends boolean = false>(options: Options<CalculateDonationData, ThrowOnError>): RequestResult<CalculateDonationResponses, CalculateDonationErrors, ThrowOnError> => (options.client ?? client).get<CalculateDonationResponses, CalculateDonationErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation-guide/calculate', ...options });

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessList = <ThrowOnError extends boolean = false>(options: Options<GetHomeDonationHistoryByDonationBusinessListData, ThrowOnError>): RequestResult<GetHomeDonationHistoryByDonationBusinessListResponses, GetHomeDonationHistoryByDonationBusinessListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeDonationHistoryByDonationBusinessListResponses, GetHomeDonationHistoryByDonationBusinessListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation/by-donation-business', ...options });

/**
 * 지자체별 통계(기부자 수, 기부금액)
 */
export const getHomeDonationStatisticsList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeDonationStatisticsListData, ThrowOnError>): RequestResult<GetHomeDonationStatisticsListResponses, GetHomeDonationStatisticsListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeDonationStatisticsListResponses, GetHomeDonationStatisticsListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-donation/statistics', ...options });

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInquiryListData, ThrowOnError>): RequestResult<GetHomeInquiryListResponses, GetHomeInquiryListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInquiryListResponses, GetHomeInquiryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-inquiry', ...options });

/**
 * 1:1 문의 상세 조회
 */
export const getHomeInquiry = <ThrowOnError extends boolean = false>(options: Options<GetHomeInquiryData, ThrowOnError>): RequestResult<GetHomeInquiryResponses, GetHomeInquiryErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInquiryResponses, GetHomeInquiryErrors, ThrowOnError>({ url: '/wello/v2/allows/home-inquiry/{homeInquiryId}', ...options });

/**
 * 시도 그룹 목록 조회
 *
 * 메인 페이지 시도 타일용. 전시 중인 그룹 중 속한 시도 하위 시군구에 전시 가능한 지자체가 1건 이상인 그룹을 노출 순서(sort) 오름차순으로 최대 10건 반환한다. 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다.
 */
export const findHomeLoveGovCodeGroupList = <ThrowOnError extends boolean = false>(options?: Options<FindHomeLoveGovCodeGroupListData, ThrowOnError>): RequestResult<FindHomeLoveGovCodeGroupListResponses, FindHomeLoveGovCodeGroupListErrors, ThrowOnError> => (options?.client ?? client).get<FindHomeLoveGovCodeGroupListResponses, FindHomeLoveGovCodeGroupListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love-gov-code-group', ...options });

/**
 * 시도 그룹 하위 시군구 지자체 코드 목록 조회
 *
 * 지정한 시도 그룹에 속한 시도들의 하위에서 전시 가능한 지자체를 보유한 시군구를 전체 지역명 가나다순으로 반환한다. 그룹 아이디를 주지 않으면 시군구 전체를 반환한다(1depth 제외, 전시 가능 조건은 동일). 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다. 존재하지 않는 그룹이나 전시 중이 아닌 그룹 아이디를 받으면 빈 목록을 반환한다.
 */
export const findHomeLoveGovCodeGroupChildList = <ThrowOnError extends boolean = false>(options?: Options<FindHomeLoveGovCodeGroupChildListData, ThrowOnError>): RequestResult<FindHomeLoveGovCodeGroupChildListResponses, FindHomeLoveGovCodeGroupChildListErrors, ThrowOnError> => (options?.client ?? client).get<FindHomeLoveGovCodeGroupChildListResponses, FindHomeLoveGovCodeGroupChildListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love-gov-code-group/child', ...options });

/**
 * 시군구 지자체 코드 목록 조회
 *
 * 지정한 광역시도 하위에서 전시 가능한 지자체를 보유한 시군구를 전체 지역명 가나다순으로 반환한다. 광역시도 아이디를 주지 않으면 시군구 전체를 반환한다(1depth 제외, 전시 가능 조건은 동일). 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다. 존재하지 않는 아이디나 광역시도가 아닌 아이디를 받으면 빈 목록을 반환한다.
 */
export const findChildHomeLoveGovCodeList = <ThrowOnError extends boolean = false>(options?: Options<FindChildHomeLoveGovCodeListData, ThrowOnError>): RequestResult<FindChildHomeLoveGovCodeListResponses, FindChildHomeLoveGovCodeListErrors, ThrowOnError> => (options?.client ?? client).get<FindChildHomeLoveGovCodeListResponses, FindChildHomeLoveGovCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love-gov-code/child', ...options });

/**
 * 광역시도 지자체 코드 목록 조회
 *
 * 하위 시군구에 전시 가능한 지자체를 보유한 광역시도를 지역명 가나다순으로 반환한다. 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다.
 */
export const findParentHomeLoveGovCodeList = <ThrowOnError extends boolean = false>(options?: Options<FindParentHomeLoveGovCodeListData, ThrowOnError>): RequestResult<FindParentHomeLoveGovCodeListResponses, FindParentHomeLoveGovCodeListErrors, ThrowOnError> => (options?.client ?? client).get<FindParentHomeLoveGovCodeListResponses, FindParentHomeLoveGovCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love-gov-code/parent', ...options });

/**
 * 고향사랑 컨텐츠 조회수 증가
 */
export const viewHomeGiftProduct = <ThrowOnError extends boolean = false>(options: Options<ViewHomeGiftProductData, ThrowOnError>): RequestResult<ViewHomeGiftProductResponses, ViewHomeGiftProductErrors, ThrowOnError> => (options.client ?? client).post<ViewHomeGiftProductResponses, ViewHomeGiftProductErrors, ThrowOnError>({
    url: '/wello/v2/allows/home-love-view',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 기부 완료 처리
 */
export const callbackComplete = <ThrowOnError extends boolean = false>(options?: Options<CallbackCompleteData, ThrowOnError>): RequestResult<CallbackCompleteResponses, CallbackCompleteErrors, ThrowOnError> => (options?.client ?? client).get<CallbackCompleteResponses, CallbackCompleteErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/donation/complete', ...options });

/**
 * 카테고리 그룹별 답례품 목록
 *
 * 선택한 카테고리 그룹에 묶인 2차 카테고리와 그 하위 답례품을 반환한다. 모든 정렬이 page · size 페이징이며 정렬 미지정은 RECOMMEND 다. RECOMMEND 는 2시간마다 갱신되는 추천 점수순(최근 선택량 · 보정 평점 · 후기 수 · 성장도 · 신규성, 노출 편중 보정)이고, 지자체 미지정 시 같은 지자체가 몰리지 않게 재배치한다(1~10위 지자체당 1개, 11~20위 누적 2개, 200위까지 연속 배치를 피한다). POPULAR 는 최근 30일 선택 건수순(취소 제외, 2시간마다 갱신), LATEST 는 최근 등록순, REVIEW_COUNT 는 후기 많은순, RATING 은 평균 평점 높은순(같으면 후기 수, 후기 없는 상품은 맨 뒤, 2시간마다 갱신)이다. 운영 중인 지자체의 전시·승인된 답례품만 대상이며 품절 상품은 기본 제외한다(includeSoldOutYN=true 면 함께 조회하고 응답 productSaleStatus 에 SOLD_OUT 이 실린다). giftCategoryGroupType 은 필수이며 ALL 을 보내면 카테고리 조건 없이 전체를 조회한다. institutionId 를 지정하면 해당 지자체만 조회한다(RECOMMEND 는 재배치 없이 점수순). giftProductPriceRangeType 은 답례품 원가 30,000원 기준 미만 · 일치 · 초과이며 할인가 · 옵션가는 보지 않는다. 두 조건은 미지정이면 적용하지 않는다.
 */
export const findGiftCategoryGroupProductList = <ThrowOnError extends boolean = false>(options: Options<FindGiftCategoryGroupProductListData, ThrowOnError>): RequestResult<FindGiftCategoryGroupProductListResponses, FindGiftCategoryGroupProductListErrors, ThrowOnError> => (options.client ?? client).get<FindGiftCategoryGroupProductListResponses, FindGiftCategoryGroupProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/category-group-gift-products', ...options });

/**
 * 지금 많이 조회하는 답례품
 *
 * 운영 중인 지자체별 정렬 1순위 답례품을 무작위 순서로 반환한다.
 */
export const findDailyPickList = <ThrowOnError extends boolean = false>(options?: Options<FindDailyPickListData, ThrowOnError>): RequestResult<FindDailyPickListResponses, FindDailyPickListErrors, ThrowOnError> => (options?.client ?? client).get<FindDailyPickListResponses, FindDailyPickListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/daily-pick', ...options });

/**
 * 주목할 만한 고향사업
 *
 * 운영 중인 지자체별 최신 전시 고향사업을 1건씩 무작위 순서로 반환한다.
 */
export const findFeaturedDonationBusinessList = <ThrowOnError extends boolean = false>(options?: Options<FindFeaturedDonationBusinessListData, ThrowOnError>): RequestResult<FindFeaturedDonationBusinessListResponses, FindFeaturedDonationBusinessListErrors, ThrowOnError> => (options?.client ?? client).get<FindFeaturedDonationBusinessListResponses, FindFeaturedDonationBusinessListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/featured-donation-businesses', ...options });

/**
 * 답례품 카테고리 그룹 목록
 *
 * 홈 화면 카테고리 탭용 그룹 목록을 반환한다. 그룹 구성은 서버에 하드코딩돼 있다. 판매 가능한 답례품(지자체 활성·전시·승인·품절 아님)이 하나도 없는 그룹은 제외하며, 「전체」는 상품 보유 여부와 무관하게 항상 첫 항목으로 포함된다. 응답 순서가 화면 노출 순서이며, groupCode 를 카테고리 그룹별 답례품 목록 조회에 그대로 넘긴다.
 */
export const findGiftCategoryGroupList = <ThrowOnError extends boolean = false>(options?: Options<FindGiftCategoryGroupListData, ThrowOnError>): RequestResult<FindGiftCategoryGroupListResponses, FindGiftCategoryGroupListErrors, ThrowOnError> => (options?.client ?? client).get<FindGiftCategoryGroupListResponses, FindGiftCategoryGroupListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/gift-category-groups', ...options });

/**
 * 지역별 특산품
 *
 * 운영 중인 지자체 중 전시 상태 특산품을 보유한 목록을 랜덤 순서로 반환한다.
 */
export const findHomeInstitutionSpecialtyList = <ThrowOnError extends boolean = false>(options?: Options<FindHomeInstitutionSpecialtyListData, ThrowOnError>): RequestResult<FindHomeInstitutionSpecialtyListResponses, FindHomeInstitutionSpecialtyListErrors, ThrowOnError> => (options?.client ?? client).get<FindHomeInstitutionSpecialtyListResponses, FindHomeInstitutionSpecialtyListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/institution-specialty', ...options });

/**
 * 주간 BEST 포토리뷰
 *
 * 어드민이 홈 전시로 지정한 포토리뷰를 수정일 최신순 최대 20건 반환한다.
 */
export const findWeeklyBestPhotoReviewList = <ThrowOnError extends boolean = false>(options?: Options<FindWeeklyBestPhotoReviewListData, ThrowOnError>): RequestResult<FindWeeklyBestPhotoReviewListResponses, FindWeeklyBestPhotoReviewListErrors, ThrowOnError> => (options?.client ?? client).get<FindWeeklyBestPhotoReviewListResponses, FindWeeklyBestPhotoReviewListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/photo-review', ...options });

/**
 * 지자체별 인기 답례품
 *
 * 지자체별 주문 수 1순위 답례품을 주문 많은 순으로 추린 뒤 무작위 순서로 반환한다.
 */
export const findPopularGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<FindPopularGiftProductListData, ThrowOnError>): RequestResult<FindPopularGiftProductListResponses, FindPopularGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindPopularGiftProductListResponses, FindPopularGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/popular-gift-products', ...options });

/**
 * 전국에서 실시간 주문중
 *
 * 호출 시각 기준 최근 24시간 내 주문된 답례품을 상품 단위로 최신순 최대 9건 반환한다.
 */
export const findRecentGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<FindRecentGiftProductListData, ThrowOnError>): RequestResult<FindRecentGiftProductListResponses, FindRecentGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindRecentGiftProductListResponses, FindRecentGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-love/main/recent-gift-products', ...options });

/**
 * 목록 조회
 */
export const getHomeNoticeList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeNoticeListData, ThrowOnError>): RequestResult<GetHomeNoticeListResponses, GetHomeNoticeListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeNoticeListResponses, GetHomeNoticeListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-notice', ...options });

/**
 * 상세 조회
 */
export const getHomeNotice = <ThrowOnError extends boolean = false>(options: Options<GetHomeNoticeData, ThrowOnError>): RequestResult<GetHomeNoticeResponses, GetHomeNoticeErrors, ThrowOnError> => (options.client ?? client).get<GetHomeNoticeResponses, GetHomeNoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-notice/{homeNoticeId}', ...options });

export const getHomePopupNotice = <ThrowOnError extends boolean = false>(options: Options<GetHomePopupNoticeData, ThrowOnError>): RequestResult<GetHomePopupNoticeResponses, GetHomePopupNoticeErrors, ThrowOnError> => (options.client ?? client).get<GetHomePopupNoticeResponses, GetHomePopupNoticeErrors, ThrowOnError>({ url: '/wello/v2/allows/home-popup-notice', ...options });

/**
 * 검색 키워드 목록 조회
 */
export const getAdminHomeSearchKeywordList = <ThrowOnError extends boolean = false>(options: Options<GetAdminHomeSearchKeywordListData, ThrowOnError>): RequestResult<GetAdminHomeSearchKeywordListResponses, GetAdminHomeSearchKeywordListErrors, ThrowOnError> => (options.client ?? client).get<GetAdminHomeSearchKeywordListResponses, GetAdminHomeSearchKeywordListErrors, ThrowOnError>({ url: '/wello/v2/allows/home-search-keyword', ...options });

/**
 * 지정 사업 목록
 */
export const getDonationBusinessList = <ThrowOnError extends boolean = false>(options?: Options<GetDonationBusinessListData, ThrowOnError>): RequestResult<GetDonationBusinessListResponses, GetDonationBusinessListErrors, ThrowOnError> => (options?.client ?? client).get<GetDonationBusinessListResponses, GetDonationBusinessListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business', ...options });

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentList = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessCommentListData, ThrowOnError>): RequestResult<GetDonationBusinessCommentListResponses, GetDonationBusinessCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetDonationBusinessCommentListResponses, GetDonationBusinessCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business-comment', ...options });

/**
 * 지자체 기부 가능한 지정 사업 조회
 */
export const getHomeInstitutionDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionDonationBusinessData, ThrowOnError>): RequestResult<GetHomeInstitutionDonationBusinessResponses, GetHomeInstitutionDonationBusinessErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionDonationBusinessResponses, GetHomeInstitutionDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/institution/{institutionId}', ...options });

/**
 * 특정 지자체 지정 사업 목록
 */
export const getInstitutionRelatedDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetInstitutionRelatedDonationBusinessData, ThrowOnError>): RequestResult<GetInstitutionRelatedDonationBusinessResponses, GetInstitutionRelatedDonationBusinessErrors, ThrowOnError> => (options.client ?? client).get<GetInstitutionRelatedDonationBusinessResponses, GetInstitutionRelatedDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/related', ...options });

/**
 * 지정 사업 상세
 */
export const getDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessData, ThrowOnError>): RequestResult<GetDonationBusinessResponses, GetDonationBusinessErrors, ThrowOnError> => (options.client ?? client).get<GetDonationBusinessResponses, GetDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}', ...options });

/**
 * 지정 사업 상세 - 기부 & 응원 수 조회
 */
export const getDonationBusinessDetailCount = <ThrowOnError extends boolean = false>(options: Options<GetDonationBusinessDetailCountData, ThrowOnError>): RequestResult<GetDonationBusinessDetailCountResponses, GetDonationBusinessDetailCountErrors, ThrowOnError> => (options.client ?? client).get<GetDonationBusinessDetailCountResponses, GetDonationBusinessDetailCountErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count', ...options });

/**
 * 관련 지정 사업 목록
 */
export const getRelatedDonationBusiness = <ThrowOnError extends boolean = false>(options: Options<GetRelatedDonationBusinessData, ThrowOnError>): RequestResult<GetRelatedDonationBusinessResponses, GetRelatedDonationBusinessErrors, ThrowOnError> => (options.client ?? client).get<GetRelatedDonationBusinessResponses, GetRelatedDonationBusinessErrors, ThrowOnError>({ url: '/wello/v2/allows/home/donation-business/{donationBusinessId}/related', ...options });

/**
 * 12월 혜택 금액 정보 조회
 */
export const getEventAmountInfo = <ThrowOnError extends boolean = false>(options?: Options<GetEventAmountInfoData, ThrowOnError>): RequestResult<GetEventAmountInfoResponses, GetEventAmountInfoErrors, ThrowOnError> => (options?.client ?? client).get<GetEventAmountInfoResponses, GetEventAmountInfoErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/benefit-amount', ...options });

/**
 * 금일 Event2 답례품
 */
export const getDecemberEventGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberEventGiftProductListData, ThrowOnError>): RequestResult<GetDecemberEventGiftProductListResponses, GetDecemberEventGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<GetDecemberEventGiftProductListResponses, GetDecemberEventGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/gift-product', ...options });

/**
 * 지역별 기부 이벤트 현황
 */
export const getDecemberInstitutionEventInfoList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberInstitutionEventInfoListData, ThrowOnError>): RequestResult<GetDecemberInstitutionEventInfoListResponses, GetDecemberInstitutionEventInfoListErrors, ThrowOnError> => (options?.client ?? client).get<GetDecemberInstitutionEventInfoListResponses, GetDecemberInstitutionEventInfoListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/institution-event', ...options });

/**
 * 랜덤티켓 당첨자 (3등 이상)
 */
export const getDecemberRandomTicketWinnerList = <ThrowOnError extends boolean = false>(options?: Options<GetDecemberRandomTicketWinnerListData, ThrowOnError>): RequestResult<GetDecemberRandomTicketWinnerListResponses, GetDecemberRandomTicketWinnerListErrors, ThrowOnError> => (options?.client ?? client).get<GetDecemberRandomTicketWinnerListResponses, GetDecemberRandomTicketWinnerListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/event/december/random-ticket-winner', ...options });

/**
 * 답례품 카테고리 목록 조회
 *
 * 하위 카테고리를 children 으로 중첩해 반환한다. 전시·승인된 상품이 서브트리에 없는 카테고리는 레벨과 무관하게 제외한다. 리프 카테고리의 children 은 빈 배열이다.
 */
export const findGiftCategoryList = <ThrowOnError extends boolean = false>(options?: Options<FindGiftCategoryListData, ThrowOnError>): RequestResult<FindGiftCategoryListResponses, FindGiftCategoryListErrors, ThrowOnError> => (options?.client ?? client).get<FindGiftCategoryListResponses, FindGiftCategoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-category', ...options });

/**
 * 최상위 답례품 카테고리 목록 조회
 *
 * 최상위(level 1) 카테고리만 반환하며 하위 카테고리는 포함하지 않는다. 전시·승인된 상품이 서브트리에 없는 카테고리는 제외한다.
 */
export const findRootGiftCategoryList = <ThrowOnError extends boolean = false>(options?: Options<FindRootGiftCategoryListData, ThrowOnError>): RequestResult<FindRootGiftCategoryListResponses, FindRootGiftCategoryListErrors, ThrowOnError> => (options?.client ?? client).get<FindRootGiftCategoryListResponses, FindRootGiftCategoryListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-category/roots', ...options });

/**
 * 답례품 목록 조회
 *
 * 운영 중인 지자체의 전시·승인된 답례품을 페이지로 반환한다. 품절 상품은 기본적으로 제외하며 includeSoldOutYN=true 면 함께 조회한다(응답 productSaleStatus 에 SOLD_OUT 이 실린다). categoryId 는 최상위 카테고리 기준이며 하위 카테고리 상품까지 함께 조회된다. searchKeyword 는 답례품명과 지자체명 3종(Long·Name·Short)을 부분 일치로 검색한다. 커스텀 정렬 대상 지자체를 institutionId 로 지정하면 giftProductSortType 을 무시하고 지자체가 어드민에서 지정한 노출 순번으로 정렬한다.
 */
export const findGiftProductList = <ThrowOnError extends boolean = false>(options?: Options<FindGiftProductListData, ThrowOnError>): RequestResult<FindGiftProductListResponses, FindGiftProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindGiftProductListResponses, FindGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product', ...options });

/**
 * 답례품 seo 조회
 */
export const getGiftProductSeo = <ThrowOnError extends boolean = false>(options: Options<GetGiftProductSeoData, ThrowOnError>): RequestResult<GetGiftProductSeoResponses, GetGiftProductSeoErrors, ThrowOnError> => (options.client ?? client).get<GetGiftProductSeoResponses, GetGiftProductSeoErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product-seo/{productNumber}', ...options });

/**
 * 추천 답례품 조회
 *
 * 오늘의 추천에 등록된 답례품이 있으면 그중에서, 등록이 하나도 없으면 전체에서 판매 가능한 답례품 무작위 1건을 반환한다. 노출·승인·품절아님·운영 중인 지자체에 더해 재고까지 반영해 실제 구매 가능한 상품만 대상으로 하며, 성인 전용 답례품은 제외한다. 등록된 답례품이 모두 판매 불가면 전체에서 고르지 않는다. 대상이 없으면 응답에서 context 키가 생략된다(NON_NULL 직렬화).
 */
export const findRecommendGiftProduct = <ThrowOnError extends boolean = false>(options?: Options<FindRecommendGiftProductData, ThrowOnError>): RequestResult<FindRecommendGiftProductResponses, FindRecommendGiftProductErrors, ThrowOnError> => (options?.client ?? client).get<FindRecommendGiftProductResponses, FindRecommendGiftProductErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/recommend', ...options });

/**
 * 특정 지자체 답례품 목록
 */
export const getInstitutionGiftProductList = <ThrowOnError extends boolean = false>(options: Options<GetInstitutionGiftProductListData, ThrowOnError>): RequestResult<GetInstitutionGiftProductListResponses, GetInstitutionGiftProductListErrors, ThrowOnError> => (options.client ?? client).get<GetInstitutionGiftProductListResponses, GetInstitutionGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/related', ...options });

/**
 * 답례품 상세 조회
 *
 * 승인·전시 여부로 걸러내지 않는다. 판매중지 상품도 조회되며 productSaleStatus 가 STOPPED 로 내려간다. 판매처 공지(noticeTitle·noticeContents)는 노출 기간 내일 때만 값이 실린다. deliveryExclusionRegionList 는 판매처가 등록한 배송불가지역(시도) 목록이며 없으면 빈 배열이다.
 */
export const findGiftProductDetail = <ThrowOnError extends boolean = false>(options: Options<FindGiftProductDetailData, ThrowOnError>): RequestResult<FindGiftProductDetailResponses, FindGiftProductDetailErrors, ThrowOnError> => (options.client ?? client).get<FindGiftProductDetailResponses, FindGiftProductDetailErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/{productNumber}', ...options });

/**
 * 관련 답례품 목록(동일 지자체) 조회
 *
 * 같은 지자체의 다른 답례품을 지자체가 지정한 노출 순서로 반환한다. 노출 순번이 없는 답례품은 뒤로 보내고 상품 아이디 내림차순으로 2차 정렬한다. 전시·승인된 답례품 중 품절이 아닌 건만 대상이며 최대 4건을 반환한다.
 */
export const findRelatedGiftProductList = <ThrowOnError extends boolean = false>(options: Options<FindRelatedGiftProductListData, ThrowOnError>): RequestResult<FindRelatedGiftProductListResponses, FindRelatedGiftProductListErrors, ThrowOnError> => (options.client ?? client).get<FindRelatedGiftProductListResponses, FindRelatedGiftProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-product/{productNumber}/related', ...options });

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewList = <ThrowOnError extends boolean = false>(options?: Options<GetGiftOrderProductReviewListData, ThrowOnError>): RequestResult<GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewListErrors, ThrowOnError> => (options?.client ?? client).get<GetGiftOrderProductReviewListResponses, GetGiftOrderProductReviewListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review', ...options });

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProduct = <ThrowOnError extends boolean = false>(options?: Options<GetGiftOrderProductPhotoReviewListByProductData, ThrowOnError>): RequestResult<GetGiftOrderProductPhotoReviewListByProductResponses, GetGiftOrderProductPhotoReviewListByProductErrors, ThrowOnError> => (options?.client ?? client).get<GetGiftOrderProductPhotoReviewListByProductResponses, GetGiftOrderProductPhotoReviewListByProductErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review/photo', ...options });

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReview = <ThrowOnError extends boolean = false>(options: Options<GetGiftOrderProductReviewData, ThrowOnError>): RequestResult<GetGiftOrderProductReviewResponses, GetGiftOrderProductReviewErrors, ThrowOnError> => (options.client ?? client).get<GetGiftOrderProductReviewResponses, GetGiftOrderProductReviewErrors, ThrowOnError>({ url: '/wello/v2/allows/home/gift-review/{reviewId}', ...options });

/**
 * 지자체 목록 조회
 *
 * 운영 중인 지자체 중 전시 상태 특산품과 답례품(전시·승인)을 모두 보유한 지자체를 가나다순으로 반환한다.
 */
export const findHomeInstitutionList = <ThrowOnError extends boolean = false>(options?: Options<FindHomeInstitutionListData, ThrowOnError>): RequestResult<FindHomeInstitutionListResponses, FindHomeInstitutionListErrors, ThrowOnError> => (options?.client ?? client).get<FindHomeInstitutionListResponses, FindHomeInstitutionListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution', ...options });

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionContentListData, ThrowOnError>): RequestResult<GetHomeInstitutionContentListResponses, GetHomeInstitutionContentListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeInstitutionContentListResponses, GetHomeInstitutionContentListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-content', ...options });

/**
 * 지자체 컨텐츠 상세 조회
 */
export const getHomeInstitutionContent = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionContentData, ThrowOnError>): RequestResult<GetHomeInstitutionContentResponses, GetHomeInstitutionContentErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionContentResponses, GetHomeInstitutionContentErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-content/{institutionContentId}', ...options });

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionEventListData, ThrowOnError>): RequestResult<GetHomeInstitutionEventListResponses, GetHomeInstitutionEventListErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeInstitutionEventListResponses, GetHomeInstitutionEventListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event', ...options });

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventList = <ThrowOnError extends boolean = false>(options?: Options<GetOrderedHomeInstitutionEventListData, ThrowOnError>): RequestResult<GetOrderedHomeInstitutionEventListResponses, GetOrderedHomeInstitutionEventListErrors, ThrowOnError> => (options?.client ?? client).get<GetOrderedHomeInstitutionEventListResponses, GetOrderedHomeInstitutionEventListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event/ordered', ...options });

/**
 * 지자체 이벤트 상세 조회
 */
export const getHomeInstitutionEvent = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionEventData, ThrowOnError>): RequestResult<GetHomeInstitutionEventResponses, GetHomeInstitutionEventErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionEventResponses, GetHomeInstitutionEventErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution-event/{institutionEventId}', ...options });

/**
 * 지자체 코드로 ID 조회
 */
export const getHomeLoveGovCodeToId = <ThrowOnError extends boolean = false>(options: Options<GetHomeLoveGovCodeToIdData, ThrowOnError>): RequestResult<GetHomeLoveGovCodeToIdResponses, GetHomeLoveGovCodeToIdErrors, ThrowOnError> => (options.client ?? client).get<GetHomeLoveGovCodeToIdResponses, GetHomeLoveGovCodeToIdErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/code-to-id/{homeLoveGovCode}', ...options });

/**
 * 지자체 목록 조회(검색필터용)
 */
export const getHomeInstitutionListForSearchFilter = <ThrowOnError extends boolean = false>(options?: Options<GetHomeInstitutionListForSearchFilterData, ThrowOnError>): RequestResult<GetHomeInstitutionListForSearchFilterResponses, GetHomeInstitutionListForSearchFilterErrors, ThrowOnError> => (options?.client ?? client).get<GetHomeInstitutionListForSearchFilterResponses, GetHomeInstitutionListForSearchFilterErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/for-search-filter', ...options });

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionPolicyListData, ThrowOnError>): RequestResult<GetHomeInstitutionPolicyListResponses, GetHomeInstitutionPolicyListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionPolicyListResponses, GetHomeInstitutionPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/policy', ...options });

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitListData, ThrowOnError>): RequestResult<GetHomeInstitutionBenefitListResponses, GetHomeInstitutionBenefitListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionBenefitListResponses, GetHomeInstitutionBenefitListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit', ...options });

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 *
 * @deprecated
 */
export const getHomeInstitutionBenefitListAll = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitListAllData, ThrowOnError>): RequestResult<GetHomeInstitutionBenefitListAllResponses, GetHomeInstitutionBenefitListAllErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionBenefitListAllResponses, GetHomeInstitutionBenefitListAllErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all', ...options });

/**
 * 위경도 기반 혜텍 제공기관 - 민영
 */
export const getHomeInstitutionBenefitPrivateList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitPrivateListData, ThrowOnError>): RequestResult<GetHomeInstitutionBenefitPrivateListResponses, GetHomeInstitutionBenefitPrivateListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionBenefitPrivateListResponses, GetHomeInstitutionBenefitPrivateListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/private', ...options });

/**
 * 위경도 기반 혜텍 제공기관 - 공영
 */
export const getHomeInstitutionBenefitPublicList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitPublicListData, ThrowOnError>): RequestResult<GetHomeInstitutionBenefitPublicListResponses, GetHomeInstitutionBenefitPublicListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionBenefitPublicListResponses, GetHomeInstitutionBenefitPublicListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/public', ...options });

/**
 * 위경도 기반 혜택 제공기관 지역별 갯수 검색
 */
export const getHomeInstitutionBenefitRegionList = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionBenefitRegionListData, ThrowOnError>): RequestResult<GetHomeInstitutionBenefitRegionListResponses, GetHomeInstitutionBenefitRegionListErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionBenefitRegionListResponses, GetHomeInstitutionBenefitRegionListErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{homeLoveGovCode}/region', ...options });

/**
 * 지자체 정보 조회
 */
export const getHomeInstitution = <ThrowOnError extends boolean = false>(options: Options<GetHomeInstitutionData, ThrowOnError>): RequestResult<GetHomeInstitutionResponses, GetHomeInstitutionErrors, ThrowOnError> => (options.client ?? client).get<GetHomeInstitutionResponses, GetHomeInstitutionErrors, ThrowOnError>({ url: '/wello/v2/allows/home/institution/{institutionId}', ...options });

/**
 * 비로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedback = <ThrowOnError extends boolean = false>(options: Options<HometownNewsFeedbackData, ThrowOnError>): RequestResult<HometownNewsFeedbackResponses, HometownNewsFeedbackErrors, ThrowOnError> => (options.client ?? client).get<HometownNewsFeedbackResponses, HometownNewsFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/feedback/{hometownNewsId}', ...options });

/**
 * 동네 소식 상세
 */
export const hometownNews = <ThrowOnError extends boolean = false>(options: Options<HometownNewsData, ThrowOnError>): RequestResult<HometownNewsResponses, HometownNewsErrors, ThrowOnError> => (options.client ?? client).get<HometownNewsResponses, HometownNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/{hometownNewsIdIdx}', ...options });

/**
 * 관련 동네소식 목록 조회(최대 10개)
 */
export const getRelatedHometownNewsList = <ThrowOnError extends boolean = false>(options: Options<GetRelatedHometownNewsListData, ThrowOnError>): RequestResult<GetRelatedHometownNewsListResponses, GetRelatedHometownNewsListErrors, ThrowOnError> => (options.client ?? client).get<GetRelatedHometownNewsListResponses, GetRelatedHometownNewsListErrors, ThrowOnError>({ url: '/wello/v2/allows/hometown-news/{hometownNewsIdIdx}/related', ...options });

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyList = <ThrowOnError extends boolean = false>(options: Options<AllowsInterestPolicyListData, ThrowOnError>): RequestResult<AllowsInterestPolicyListResponses, AllowsInterestPolicyListErrors, ThrowOnError> => (options.client ?? client).get<AllowsInterestPolicyListResponses, AllowsInterestPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/interest-policy', ...options });

/**
 * 카카오뱅크 로그인(login_key 교환)
 *
 * 카카오뱅크 앱이 웹뷰 첫 페이지(카카오뱅크 전용 프론트) 요청에 주입한 login_key·kkb_di 헤더값을 프론트 서버가 그대로 담아 호출한다. 결과조회(폴링)로 login_key를 검증하고 가입자는 로그인 토큰(accessToken/refreshToken)을, 미가입자는 signupRequired=true와 가입 요청에 첨부할 entryToken을 반환한다. 검증 완료 login_key는 TTL 내 재교환이 허용된다(새로고침·재시도 멱등). 검증 실패는 returnCode 30400.
 */
export const createLoginToken = <ThrowOnError extends boolean = false>(options: Options<CreateLoginTokenData, ThrowOnError>): RequestResult<CreateLoginTokenResponses, CreateLoginTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateLoginTokenResponses, CreateLoginTokenErrors, ThrowOnError>({
    url: '/wello/v2/allows/kakao-bank/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 세션시작(카카오뱅크 앱 전용 — 프론트 서버가 릴레이)
 *
 * 카카오뱅크 앱의 session_url 호출을 프론트 서버가 받아 그대로 넘긴 요청을 처리한다. 로그인키제공 API를 호출하고 trx_key를 카카오뱅크 규격으로 반환한다. kkb_di는 헤더로, 웹뷰 첫 페이지 랜딩 URL은 요청 본문의 target으로 받는다 — target은 프론트 서버가 만든 전체 URL이며, 허용 도메인이면 로그인키제공 요청의 landing_url로 그대로 전달한다. kkb_di나 target이 없거나 target이 허용 도메인이 아니면 카카오뱅크 규격 실패 응답(AC9104 — 서비스 요청 파라미터 오류)을 낸다. 로그인키제공 호출이 실패하면 카카오뱅크가 준 코드를, 응답을 못 받았으면 AC9003을, 접근토큰 확보 실패·진입 트랜잭션 저장 실패 등 웰로 쪽 문제면 AC9000을 낸다.
 */
export const startSession = <ThrowOnError extends boolean = false>(options?: Options<StartSessionData, ThrowOnError>): RequestResult<StartSessionResponses, StartSessionErrors, ThrowOnError> => (options?.client ?? client).post<StartSessionResponses, StartSessionErrors, ThrowOnError>({
    url: '/wello/v2/allows/kakao-bank/session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * 가입 완료 처리
 *
 * 통합인증창 완료 신호 후 호출합니다. 인증 결과 2건을 수거해 회원을 생성하고 로그인 토큰을 발급합니다.
 * FAILED면 kakaoBankResponseCode를 [코드] 형식으로 노출해야 합니다(없으면 생략).
 * 오류: 30400(진입·세션 만료, 결과 처리 실패), 30409(동일인 계정 존재 — 고객센터 안내)
 */
export const completeSignup = <ThrowOnError extends boolean = false>(options: Options<CompleteSignupData, ThrowOnError>): RequestResult<CompleteSignupResponses, CompleteSignupErrors, ThrowOnError> => (options.client ?? client).post<CompleteSignupResponses, CompleteSignupErrors, ThrowOnError>({
    url: '/wello/v2/allows/kakao-bank/signup/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 가입 인증 시작
 *
 * 카카오뱅크에 부가정보제공·본인확인을 접수하고 통합인증창 구동용 compositeKey를 반환합니다.
 * 이미 가입된 회원이면 alreadySignedUp=true와 로그인 토큰으로 즉시 종결합니다(멱등).
 * 호출할 때마다 새로 접수합니다(진행 중인 인증요청을 재사용하지 않음).
 * 마케팅 수신 동의는 받지 않으며 회원은 미동의로 가입합니다.
 * 오류: 30400(진입 만료·접수 실패 — 재진입/재시도 유도)
 */
export const startSignup = <ThrowOnError extends boolean = false>(options: Options<StartSignupData, ThrowOnError>): RequestResult<StartSignupResponses, StartSignupErrors, ThrowOnError> => (options.client ?? client).post<StartSignupResponses, StartSignupErrors, ThrowOnError>({
    url: '/wello/v2/allows/kakao-bank/signup/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 이벤트 참여 요청
 */
export const joinEvent = <ThrowOnError extends boolean = false>(options: Options<JoinEventData, ThrowOnError>): RequestResult<JoinEventResponses, JoinEventErrors, ThrowOnError> => (options.client ?? client).post<JoinEventResponses, JoinEventErrors, ThrowOnError>({
    url: '/wello/v2/allows/kb',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KB PAY 회원 탈회
 */
export const resignWelloWithKbPay = <ThrowOnError extends boolean = false>(options: Options<ResignWelloWithKbPayData, ThrowOnError>): RequestResult<ResignWelloWithKbPayResponses, ResignWelloWithKbPayErrors, ThrowOnError> => (options.client ?? client).delete<ResignWelloWithKbPayResponses, ResignWelloWithKbPayErrors, ThrowOnError>({
    url: '/wello/v2/allows/kb-pay',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * KB PAY 회원 웰로 로그인
 *
 * @deprecated
 */
export const loginWelloWithKbPay1 = <ThrowOnError extends boolean = false>(options: Options<LoginWelloWithKbPay1Data, ThrowOnError>): RequestResult<LoginWelloWithKbPay1Responses, LoginWelloWithKbPay1Errors, ThrowOnError> => (options.client ?? client).post<LoginWelloWithKbPay1Responses, LoginWelloWithKbPay1Errors, ThrowOnError>({
    url: '/wello/v2/allows/kb-pay/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 지역별 특산품
 */
export const getInstitutionSpecialtyList = <ThrowOnError extends boolean = false>(options?: Options<GetInstitutionSpecialtyListData, ThrowOnError>): RequestResult<GetInstitutionSpecialtyListResponses, GetInstitutionSpecialtyListErrors, ThrowOnError> => (options?.client ?? client).get<GetInstitutionSpecialtyListResponses, GetInstitutionSpecialtyListErrors, ThrowOnError>({ url: '/wello/v2/allows/local-festa/institution-specialty', ...options });

/**
 * 일반 다운로드 가능 쿠폰 목록 조회 (공개)
 *
 * 비인증 사용자용 상품별 일반 다운로드 가능 쿠폰 목록 조회
 */
export const findGeneralDownloadableCoupons = <ThrowOnError extends boolean = false>(options: Options<FindGeneralDownloadableCouponsData, ThrowOnError>): RequestResult<FindGeneralDownloadableCouponsResponses, FindGeneralDownloadableCouponsErrors, ThrowOnError> => (options.client ?? client).get<FindGeneralDownloadableCouponsResponses, FindGeneralDownloadableCouponsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/coupons/downloadable', ...options });

/**
 * 기부자 만족 상품 피드 조회 (메인 화면)
 *
 * 기부자 만족 상품 피드 조회.
 *
 * <p>상품 ID로 매핑된 답례품의 기부자 만족도와 리뷰 미리보기를 반환합니다.
 * 리뷰는 최신순 N건만 반환됩니다.</p>
 */
export const getGiftReviewFeed = <ThrowOnError extends boolean = false>(options: Options<GetGiftReviewFeedData, ThrowOnError>): RequestResult<GetGiftReviewFeedResponses, GetGiftReviewFeedErrors, ThrowOnError> => (options.client ?? client).get<GetGiftReviewFeedResponses, GetGiftReviewFeedErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/gift-review-feed/{productId}', ...options });

/**
 * NicePay 인증 결과 수신 (returnUrl)
 *
 * NicePay 인증 결과 수신 및 결제 승인 처리.
 *
 * <p>Content-Type: application/x-www-form-urlencoded
 * NicePay가 POST로 전송하는 파라미터를 @RequestParam으로 수신한다.
 * 처리 후 프론트엔드 성공/실패 페이지로 302 redirect한다.</p>
 */
export const handleAuthResult = <ThrowOnError extends boolean = false>(options: Options<HandleAuthResultData, ThrowOnError>): RequestResult<HandleAuthResultResponses, HandleAuthResultErrors, ThrowOnError> => (options.client ?? client).post<HandleAuthResultResponses, HandleAuthResultErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/payments/auth-result', ...options });

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedList = <ThrowOnError extends boolean = false>(options?: Options<GetProductFeedListData, ThrowOnError>): RequestResult<GetProductFeedListResponses, GetProductFeedListErrors, ThrowOnError> => (options?.client ?? client).get<GetProductFeedListResponses, GetProductFeedListErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/product-feeds', ...options });

/**
 * 상품번호로 상품 상세 조회
 *
 * 상품번호로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>}</p>
 *
 * <p>상품번호(productNumber)는 상품 등록 시 자동 생성되는 고유 식별자이다.
 * 컨트롤러 레벨에서 정규식 패턴을 검증하여, 형식에 맞지 않는 요청은
 * DB 조회 없이 즉시 에러를 반환한다.</p>
 */
export const getProductDetailByProductNumber = <ThrowOnError extends boolean = false>(options: Options<GetProductDetailByProductNumberData, ThrowOnError>): RequestResult<GetProductDetailByProductNumberResponses, GetProductDetailByProductNumberErrors, ThrowOnError> => (options.client ?? client).get<GetProductDetailByProductNumberResponses, GetProductDetailByProductNumberErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/by-product-number/{productNumber}', ...options });

/**
 * 상품번호로 SEO 정보 조회 (비인증)
 *
 * 상품번호로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>/seo}</p>
 */
export const getProductSeo = <ThrowOnError extends boolean = false>(options: Options<GetProductSeoData, ThrowOnError>): RequestResult<GetProductSeoResponses, GetProductSeoErrors, ThrowOnError> => (options.client ?? client).get<GetProductSeoResponses, GetProductSeoErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/by-product-number/{productNumber}/seo', ...options });

/**
 * 상품 상세 조회
 *
 * 상품 ID(UUID)로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>}</p>
 *
 * <p>Spring이 <code>@PathVariable UUID</code> 타입 변환 시 UUID 형식이 아니면 자동으로 400 에러를 반환한다.</p>
 */
export const getProductDetail = <ThrowOnError extends boolean = false>(options: Options<GetProductDetailData, ThrowOnError>): RequestResult<GetProductDetailResponses, GetProductDetailErrors, ThrowOnError> => (options.client ?? client).get<GetProductDetailResponses, GetProductDetailErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}', ...options });

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiries = <ThrowOnError extends boolean = false>(options: Options<FindAllInquiriesData, ThrowOnError>): RequestResult<FindAllInquiriesResponses, FindAllInquiriesErrors, ThrowOnError> => (options.client ?? client).get<FindAllInquiriesResponses, FindAllInquiriesErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/inquiries', ...options });

/**
 * 상품 문의 상세 조회
 *
 * 상품 문의 상세 조회
 */
export const findInquiry = <ThrowOnError extends boolean = false>(options: Options<FindInquiryData, ThrowOnError>): RequestResult<FindInquiryResponses, FindInquiryErrors, ThrowOnError> => (options.client ?? client).get<FindInquiryResponses, FindInquiryErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/inquiries/{inquiryId}', ...options });

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviews = <ThrowOnError extends boolean = false>(options: Options<FindReviewsData, ThrowOnError>): RequestResult<FindReviewsResponses, FindReviewsErrors, ThrowOnError> => (options.client ?? client).get<FindReviewsResponses, FindReviewsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews', ...options });

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviews = <ThrowOnError extends boolean = false>(options: Options<FindPhotoReviewsData, ThrowOnError>): RequestResult<FindPhotoReviewsResponses, FindPhotoReviewsErrors, ThrowOnError> => (options.client ?? client).get<FindPhotoReviewsResponses, FindPhotoReviewsErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews/photos', ...options });

/**
 * 상품 리뷰 상세 조회
 *
 * 상품 리뷰 상세를 조회한다.
 */
export const findReview = <ThrowOnError extends boolean = false>(options: Options<FindReviewData, ThrowOnError>): RequestResult<FindReviewResponses, FindReviewErrors, ThrowOnError> => (options.client ?? client).get<FindReviewResponses, FindReviewErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/reviews/{reviewId}', ...options });

/**
 * 상품 ID로 SEO 정보 조회 (비인증)
 *
 * 상품 ID(UUID)로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>/seo}</p>
 */
export const getProductSeoByProductId = <ThrowOnError extends boolean = false>(options: Options<GetProductSeoByProductIdData, ThrowOnError>): RequestResult<GetProductSeoByProductIdResponses, GetProductSeoByProductIdErrors, ThrowOnError> => (options.client ?? client).get<GetProductSeoByProductIdResponses, GetProductSeoByProductIdErrors, ThrowOnError>({ url: '/wello/v2/allows/local-market/products/{productId}/seo', ...options });

/**
 * 약관 변경 이력을 조회합니다.
 *
 * 약관 변경이력 조회
 */
export const termHistory = <ThrowOnError extends boolean = false>(options: Options<TermHistoryData, ThrowOnError>): RequestResult<TermHistoryResponses, TermHistoryErrors, ThrowOnError> => (options.client ?? client).get<TermHistoryResponses, TermHistoryErrors, ThrowOnError>({ url: '/wello/v2/allows/log-term/{termCategory}', ...options });

/**
 * 현재 활성화된 점검 목록 조회
 *
 * 현재 활성화된 점검 목록 조회
 */
export const getActiveMaintenanceList = <ThrowOnError extends boolean = false>(options?: Options<GetActiveMaintenanceListData, ThrowOnError>): RequestResult<GetActiveMaintenanceListResponses, GetActiveMaintenanceListErrors, ThrowOnError> => (options?.client ?? client).get<GetActiveMaintenanceListResponses, GetActiveMaintenanceListErrors, ThrowOnError>({ url: '/wello/v2/allows/maintenance/active', ...options });

/**
 * 특정 점검 상세 조회
 *
 * 특정 점검 상세 조회
 */
export const getMaintenance = <ThrowOnError extends boolean = false>(options: Options<GetMaintenanceData, ThrowOnError>): RequestResult<GetMaintenanceResponses, GetMaintenanceErrors, ThrowOnError> => (options.client ?? client).get<GetMaintenanceResponses, GetMaintenanceErrors, ThrowOnError>({ url: '/wello/v2/allows/maintenance/check/{id}', ...options });

/**
 * 중위소득 조회
 */
export const getMedianIncomeList = <ThrowOnError extends boolean = false>(options?: Options<GetMedianIncomeListData, ThrowOnError>): RequestResult<GetMedianIncomeListResponses, GetMedianIncomeListErrors, ThrowOnError> => (options?.client ?? client).get<GetMedianIncomeListResponses, GetMedianIncomeListErrors, ThrowOnError>({ url: '/wello/v2/allows/median-income', ...options });

/**
 * 웰로 회원 탈퇴(관리자용, 다건)
 *
 * 최대 100명까지 일괄 탈퇴 처리한다. 요청한 memberOAuthId 중 웰로 회원이 아닌 건(returnCode 30404)이나 외부 채널(KB·카카오뱅크) 연동 회원(returnCode 30400)이 하나라도 있으면 아무것도 처리하지 않고 해당 memberOAuthId 목록을 담은 오류를 반환한다. 외부 채널 연동 회원은 외부 채널 회원 탈퇴 API 를 사용한다.
 */
export const resignMembers = <ThrowOnError extends boolean = false>(options: Options<ResignMembersData, ThrowOnError>): RequestResult<ResignMembersResponses, ResignMembersErrors, ThrowOnError> => (options.client ?? client).delete<ResignMembersResponses, ResignMembersErrors, ThrowOnError>({
    url: '/wello/v2/allows/member',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const welloBeforeLogin = <ThrowOnError extends boolean = false>(options: Options<WelloBeforeLoginData, ThrowOnError>): RequestResult<WelloBeforeLoginResponses, WelloBeforeLoginErrors, ThrowOnError> => (options.client ?? client).post<WelloBeforeLoginResponses, WelloBeforeLoginErrors, ThrowOnError>({
    url: '/wello/v2/allows/member-oauth/before/sns/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const getKbMemberLoginTypeList1 = <ThrowOnError extends boolean = false>(options: Options<GetKbMemberLoginTypeList1Data, ThrowOnError>): RequestResult<GetKbMemberLoginTypeList1Responses, GetKbMemberLoginTypeList1Errors, ThrowOnError> => (options.client ?? client).get<GetKbMemberLoginTypeList1Responses, GetKbMemberLoginTypeList1Errors, ThrowOnError>({ url: '/wello/v2/allows/member-oauth/kb-member-login-type', ...options });

/**
 * @deprecated
 */
export const loginWelloSnsMember1 = <ThrowOnError extends boolean = false>(options: Options<LoginWelloSnsMember1Data, ThrowOnError>): RequestResult<LoginWelloSnsMember1Responses, LoginWelloSnsMember1Errors, ThrowOnError> => (options.client ?? client).post<LoginWelloSnsMember1Responses, LoginWelloSnsMember1Errors, ThrowOnError>({
    url: '/wello/v2/allows/member-oauth/sns/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const snsRefreshToken1 = <ThrowOnError extends boolean = false>(options: Options<SnsRefreshToken1Data, ThrowOnError>): RequestResult<SnsRefreshToken1Responses, SnsRefreshToken1Errors, ThrowOnError> => (options.client ?? client).get<SnsRefreshToken1Responses, SnsRefreshToken1Errors, ThrowOnError>({ url: '/wello/v2/allows/member-oauth/sns/refresh-token', ...options });

/**
 * 신규 닉네임 조회
 *
 * 신규 닉네임을 조회합니다
 */
export const noticeList = <ThrowOnError extends boolean = false>(options?: Options<NoticeListData, ThrowOnError>): RequestResult<NoticeListResponses, NoticeListErrors, ThrowOnError> => (options?.client ?? client).get<NoticeListResponses, NoticeListErrors, ThrowOnError>({ url: '/wello/v2/allows/member-wello/nickname', ...options });

/**
 * 외부 채널 연동 회원 탈퇴(관리자용, 단건)
 *
 * KB·카카오뱅크 등 외부 채널에 연동된 회원을 탈퇴 처리한다. 웰로 쪽 탈퇴가 커밋된 뒤 KB 는 철회 API 호출, 카카오뱅크는 탈퇴 통지를 보내므로, 성공 응답은 웰로 탈퇴 완료를 뜻하고 외부 채널 결과는 포함하지 않는다. 외부 채널 연동 회원이 아니면 returnCode 30400 을 반환한다. 다건은 지원하지 않는다.
 */
export const resignExternalChannelMember = <ThrowOnError extends boolean = false>(options: Options<ResignExternalChannelMemberData, ThrowOnError>): RequestResult<ResignExternalChannelMemberResponses, ResignExternalChannelMemberErrors, ThrowOnError> => (options.client ?? client).delete<ResignExternalChannelMemberResponses, ResignExternalChannelMemberErrors, ThrowOnError>({
    url: '/wello/v2/allows/member/external-channel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectMessage = <ThrowOnError extends boolean = false>(options: Options<RejectMessageData, ThrowOnError>): RequestResult<RejectMessageResponses, RejectMessageErrors, ThrowOnError> => (options.client ?? client).put<RejectMessageResponses, RejectMessageErrors, ThrowOnError>({
    url: '/wello/v2/allows/message-reject/member-wello',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 메타코드 정보 조회
 *
 * 메타코드 및 메타코드의 하위 코드까지 조회합니다
 */
export const metaCodeAll = <ThrowOnError extends boolean = false>(options: Options<MetaCodeAllData, ThrowOnError>): RequestResult<MetaCodeAllResponses, MetaCodeAllErrors, ThrowOnError> => (options.client ?? client).get<MetaCodeAllResponses, MetaCodeAllErrors, ThrowOnError>({ url: '/wello/v2/allows/meta-code', ...options });

/**
 * 공통코드 초기화
 *
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const commonCodeInit = <ThrowOnError extends boolean = false>(options: Options<CommonCodeInitData, ThrowOnError>): RequestResult<CommonCodeInitResponses, CommonCodeInitErrors, ThrowOnError> => (options.client ?? client).post<CommonCodeInitResponses, CommonCodeInitErrors, ThrowOnError>({ url: '/wello/v2/allows/meta-code/reset', ...options });

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSuccess = <ThrowOnError extends boolean = false>(options: Options<CheckPlusSuccessData, ThrowOnError>): RequestResult<CheckPlusSuccessResponses, CheckPlusSuccessErrors, ThrowOnError> => (options.client ?? client).get<CheckPlusSuccessResponses, CheckPlusSuccessErrors, ThrowOnError>({ url: '/wello/v2/allows/nice-safe-key/check-plus_success', ...options });

/**
 * 비회원 맞춤 정책 검색목록 조회
 */
export const getNonMemberSuggestPolicyList = <ThrowOnError extends boolean = false>(options: Options<GetNonMemberSuggestPolicyListData, ThrowOnError>): RequestResult<GetNonMemberSuggestPolicyListResponses, GetNonMemberSuggestPolicyListErrors, ThrowOnError> => (options.client ?? client).get<GetNonMemberSuggestPolicyListResponses, GetNonMemberSuggestPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/non-member-suggest-policy', ...options });

/**
 * 룰렛 구성 조회
 *
 * 진행 중(ACTIVE) 룰렛 이벤트의 기간과 경품 등급 목록을 반환합니다. 진행 중인 이벤트가 없으면 30404. 등급별 잔여 수량은 노출하지 않으며, 휠 칸 배치는 FE 가 결정합니다.
 */
export const findNonsanRoulette = <ThrowOnError extends boolean = false>(options?: Options<FindNonsanRouletteData, ThrowOnError>): RequestResult<FindNonsanRouletteResponses, FindNonsanRouletteErrors, ThrowOnError> => (options?.client ?? client).get<FindNonsanRouletteResponses, FindNonsanRouletteErrors, ThrowOnError>({ url: '/wello/v2/allows/nonsan-roulette', ...options });

/**
 * 상품 목록 조회
 */
export const getPointMarketProductList = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketProductListData, ThrowOnError>): RequestResult<GetPointMarketProductListResponses, GetPointMarketProductListErrors, ThrowOnError> => (options?.client ?? client).get<GetPointMarketProductListResponses, GetPointMarketProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product', ...options });

/**
 * 브랜드별 상품 목록 조회 (페이징 없음)
 */
export const getPointMarketProductListByBrand = <ThrowOnError extends boolean = false>(options?: Options<GetPointMarketProductListByBrandData, ThrowOnError>): RequestResult<GetPointMarketProductListByBrandResponses, GetPointMarketProductListByBrandErrors, ThrowOnError> => (options?.client ?? client).get<GetPointMarketProductListByBrandResponses, GetPointMarketProductListByBrandErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/by-brand', ...options });

/**
 * 다우기술 전체 상품정보 조회
 *
 * 다우기술 운영 서버에서 전체 상품정보를 내려받아 DB 저장 없이 그대로 반환한다.
 */
export const findDaouProductList = <ThrowOnError extends boolean = false>(options?: Options<FindDaouProductListData, ThrowOnError>): RequestResult<FindDaouProductListResponses, FindDaouProductListErrors, ThrowOnError> => (options?.client ?? client).get<FindDaouProductListResponses, FindDaouProductListErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/daou', ...options });

/**
 * 상품 상세 조회(+ 지금 본 상품과 비슷한 상품 목록)
 */
export const getPointMarketProduct = <ThrowOnError extends boolean = false>(options: Options<GetPointMarketProductData, ThrowOnError>): RequestResult<GetPointMarketProductResponses, GetPointMarketProductErrors, ThrowOnError> => (options.client ?? client).get<GetPointMarketProductResponses, GetPointMarketProductErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/{productIdIdx}', ...options });

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProduct = <ThrowOnError extends boolean = false>(options: Options<FeedbackPointMarketProductData, ThrowOnError>): RequestResult<FeedbackPointMarketProductResponses, FeedbackPointMarketProductErrors, ThrowOnError> => (options.client ?? client).post<FeedbackPointMarketProductResponses, FeedbackPointMarketProductErrors, ThrowOnError>({ url: '/wello/v2/allows/point-market/product/{productIdIdx}/feedback', ...options });

/**
 * 내 상황에 맞는 정책 카테고리
 */
export const getListPolicyCaseCategory = <ThrowOnError extends boolean = false>(options?: Options<GetListPolicyCaseCategoryData, ThrowOnError>): RequestResult<GetListPolicyCaseCategoryResponses, GetListPolicyCaseCategoryErrors, ThrowOnError> => (options?.client ?? client).get<GetListPolicyCaseCategoryResponses, GetListPolicyCaseCategoryErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-case/category', ...options });

/**
 * 지역 좌표 목록 조회
 */
export const getPolicyCodeGeocodingList = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyCodeGeocodingListData, ThrowOnError>): RequestResult<GetPolicyCodeGeocodingListResponses, GetPolicyCodeGeocodingListErrors, ThrowOnError> => (options?.client ?? client).get<GetPolicyCodeGeocodingListResponses, GetPolicyCodeGeocodingListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-code-geocoding', ...options });

/**
 * 정책 사전 목록 조회
 */
export const getPolicyDictionaryList = <ThrowOnError extends boolean = false>(options?: Options<GetPolicyDictionaryListData, ThrowOnError>): RequestResult<GetPolicyDictionaryListResponses, GetPolicyDictionaryListErrors, ThrowOnError> => (options?.client ?? client).get<GetPolicyDictionaryListResponses, GetPolicyDictionaryListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy-dictionary', ...options });

/**
 * 비로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedback = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyFeedbackData, ThrowOnError>): RequestResult<MetaPolicyFeedbackResponses, MetaPolicyFeedbackErrors, ThrowOnError> => (options.client ?? client).get<MetaPolicyFeedbackResponses, MetaPolicyFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/feedback/{policyId}', ...options });

/**
 * 비회원 인기정책 조회
 */
export const popularPolicyList = <ThrowOnError extends boolean = false>(options?: Options<PopularPolicyListData, ThrowOnError>): RequestResult<PopularPolicyListResponses, PopularPolicyListErrors, ThrowOnError> => (options?.client ?? client).get<PopularPolicyListResponses, PopularPolicyListErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/popular', ...options });

/**
 * 비회원 정책 상세 조회
 */
export const metaPolicy = <ThrowOnError extends boolean = false>(options: Options<MetaPolicyData, ThrowOnError>): RequestResult<MetaPolicyResponses, MetaPolicyErrors, ThrowOnError> => (options.client ?? client).get<MetaPolicyResponses, MetaPolicyErrors, ThrowOnError>({ url: '/wello/v2/allows/policy/{metaPolicyIdIdx}', ...options });

/**
 * 정책 AI 정보 업데이트
 */
export const updatePolicyAiInfo = <ThrowOnError extends boolean = false>(options: Options<UpdatePolicyAiInfoData, ThrowOnError>): RequestResult<UpdatePolicyAiInfoResponses, UpdatePolicyAiInfoErrors, ThrowOnError> => (options.client ?? client).put<UpdatePolicyAiInfoResponses, UpdatePolicyAiInfoErrors, ThrowOnError>({
    url: '/wello/v2/allows/policy/{metaPolicyIdIdx}/ai',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 정책소식 검색
 */
export const findBestContents = <ThrowOnError extends boolean = false>(options: Options<FindBestContentsData, ThrowOnError>): RequestResult<FindBestContentsResponses, FindBestContentsErrors, ThrowOnError> => (options.client ?? client).get<FindBestContentsResponses, FindBestContentsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/best-contents', ...options });

/**
 * 지정기부사업 검색
 */
export const findDonationBusinesses = <ThrowOnError extends boolean = false>(options?: Options<FindDonationBusinessesData, ThrowOnError>): RequestResult<FindDonationBusinessesResponses, FindDonationBusinessesErrors, ThrowOnError> => (options?.client ?? client).get<FindDonationBusinessesResponses, FindDonationBusinessesErrors, ThrowOnError>({ url: '/wello/v2/allows/query/donations-businesses', ...options });

/**
 * 답례품 검색
 */
export const findGiftProducts = <ThrowOnError extends boolean = false>(options?: Options<FindGiftProductsData, ThrowOnError>): RequestResult<FindGiftProductsResponses, FindGiftProductsErrors, ThrowOnError> => (options?.client ?? client).get<FindGiftProductsResponses, FindGiftProductsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/gift-products', ...options });

/**
 * 동네소식 검색
 */
export const findHometownNews = <ThrowOnError extends boolean = false>(options?: Options<FindHometownNewsData, ThrowOnError>): RequestResult<FindHometownNewsResponses, FindHometownNewsErrors, ThrowOnError> => (options?.client ?? client).get<FindHometownNewsResponses, FindHometownNewsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/hometown-news', ...options });

/**
 * 통합검색
 *
 * 검색어로 정책·동네소식·정책소식·답례품·지정기부사업·웰마켓을 병렬 검색해 카테고리별 블록으로 종합 반환한다. 축제는 festivalSubRegionCode+festivalRadius가 있을 때만 포함한다. 각 블록은 기존 카테고리 응답과 동일하다.
 */
export const findIntegrated = <ThrowOnError extends boolean = false>(options?: Options<FindIntegratedData, ThrowOnError>): RequestResult<FindIntegratedResponses, FindIntegratedErrors, ThrowOnError> => (options?.client ?? client).get<FindIntegratedResponses, FindIntegratedErrors, ThrowOnError>({ url: '/wello/v2/allows/query/integrated', ...options });

/**
 * 웰마켓 검색
 */
export const findLocalMarketProducts = <ThrowOnError extends boolean = false>(options?: Options<FindLocalMarketProductsData, ThrowOnError>): RequestResult<FindLocalMarketProductsResponses, FindLocalMarketProductsErrors, ThrowOnError> => (options?.client ?? client).get<FindLocalMarketProductsResponses, FindLocalMarketProductsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/local-market', ...options });

/**
 * 정책 검색
 */
export const findPolicies = <ThrowOnError extends boolean = false>(options?: Options<FindPoliciesData, ThrowOnError>): RequestResult<FindPoliciesResponses, FindPoliciesErrors, ThrowOnError> => (options?.client ?? client).get<FindPoliciesResponses, FindPoliciesErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies', ...options });

/**
 * 정책 검색 - 연령
 */
export const findQueryAgeCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryAgeCodeData, ThrowOnError>): RequestResult<FindQueryAgeCodeResponses, FindQueryAgeCodeErrors, ThrowOnError> => (options?.client ?? client).get<FindQueryAgeCodeResponses, FindQueryAgeCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/age', ...options });

/**
 * 정책 검색 - 직업
 */
export const findQueryJobCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryJobCodeData, ThrowOnError>): RequestResult<FindQueryJobCodeResponses, FindQueryJobCodeErrors, ThrowOnError> => (options?.client ?? client).get<FindQueryJobCodeResponses, FindQueryJobCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/job', ...options });

/**
 * 정책 검색, 정책 활용 가이드 - 지원형태
 */
export const findQueryProvisionCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryProvisionCodeData, ThrowOnError>): RequestResult<FindQueryProvisionCodeResponses, FindQueryProvisionCodeErrors, ThrowOnError> => (options?.client ?? client).get<FindQueryProvisionCodeResponses, FindQueryProvisionCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/provision', ...options });

/**
 * 정책 검색 - 대상
 */
export const findQueryTargetCode = <ThrowOnError extends boolean = false>(options?: Options<FindQueryTargetCodeData, ThrowOnError>): RequestResult<FindQueryTargetCodeResponses, FindQueryTargetCodeErrors, ThrowOnError> => (options?.client ?? client).get<FindQueryTargetCodeResponses, FindQueryTargetCodeErrors, ThrowOnError>({ url: '/wello/v2/allows/query/policies/codes/target', ...options });

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivals = <ThrowOnError extends boolean = false>(options: Options<FindTourFestivalsData, ThrowOnError>): RequestResult<FindTourFestivalsResponses, FindTourFestivalsErrors, ThrowOnError> => (options.client ?? client).get<FindTourFestivalsResponses, FindTourFestivalsErrors, ThrowOnError>({ url: '/wello/v2/allows/query/tour/festival', ...options });

/**
 * 파일 삭제
 */
export const fileDelete = <ThrowOnError extends boolean = false>(options: Options<FileDeleteData, ThrowOnError>): RequestResult<FileDeleteResponses, FileDeleteErrors, ThrowOnError> => (options.client ?? client).delete<FileDeleteResponses, FileDeleteErrors, ThrowOnError>({
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 파일 업로드
 */
export const fileUpload = <ThrowOnError extends boolean = false>(options?: Options<FileUploadData, ThrowOnError>): RequestResult<FileUploadResponses, FileUploadErrors, ThrowOnError> => (options?.client ?? client).post<FileUploadResponses, FileUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYn = <ThrowOnError extends boolean = false>(options: Options<UpdateFileTempSaveYnData, ThrowOnError>): RequestResult<UpdateFileTempSaveYnResponses, UpdateFileTempSaveYnErrors, ThrowOnError> => (options.client ?? client).put<UpdateFileTempSaveYnResponses, UpdateFileTempSaveYnErrors, ThrowOnError>({
    url: '/wello/v2/allows/s3',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 비회원 파일 복호화 다운로드
 */
export const fileDecryptionDownload = <ThrowOnError extends boolean = false>(options: Options<FileDecryptionDownloadData, ThrowOnError>): RequestResult<FileDecryptionDownloadResponses, FileDecryptionDownloadErrors, ThrowOnError> => (options.client ?? client).get<FileDecryptionDownloadResponses, FileDecryptionDownloadErrors, ThrowOnError>({ url: '/wello/v2/allows/s3/nonmember-decryption', ...options });

/**
 * 약관을 조회합니다.
 *
 * 약관 조회
 */
export const term = <ThrowOnError extends boolean = false>(options: Options<TermData, ThrowOnError>): RequestResult<TermResponses, TermErrors, ThrowOnError> => (options.client ?? client).get<TermResponses, TermErrors, ThrowOnError>({ url: '/wello/v2/allows/term/{termCategory}', ...options });

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedback = <ThrowOnError extends boolean = false>(options: Options<FindTourFeedbackData, ThrowOnError>): RequestResult<FindTourFeedbackResponses, FindTourFeedbackErrors, ThrowOnError> => (options.client ?? client).get<FindTourFeedbackResponses, FindTourFeedbackErrors, ThrowOnError>({ url: '/wello/v2/allows/tour/feedback/{tourId}', ...options });

/**
 * 투어 거리 조회 (비로그인 허용)
 *
 * subRegionCode 중심 좌표로부터 투어 point 까지의 거리(미터)를 계산한다. 중심 좌표 미존재 시 30404, 좌표 손상 시 30400, 투어 미존재/비공개 시 30404. point 없으면 distance=null.
 */
export const findTourDistance = <ThrowOnError extends boolean = false>(options: Options<FindTourDistanceData, ThrowOnError>): RequestResult<FindTourDistanceResponses, FindTourDistanceErrors, ThrowOnError> => (options.client ?? client).get<FindTourDistanceResponses, FindTourDistanceErrors, ThrowOnError>({ url: '/wello/v2/allows/tour/{tourId}/distance', ...options });

/**
 * 인기검색어 순위 조회
 *
 * 최신 스냅샷의 인기검색어 순위(▲▼·급상승·신규 배지 포함)를 반환한다. 첫 배치 전에는 빈 목록이다.
 */
export const findTrend = <ThrowOnError extends boolean = false>(options?: Options<FindTrendData, ThrowOnError>): RequestResult<FindTrendResponses, FindTrendErrors, ThrowOnError> => (options?.client ?? client).get<FindTrendResponses, FindTrendErrors, ThrowOnError>({ url: '/wello/v2/allows/trend', ...options });

/**
 * URL 매핑 상세 조회
 *
 * URL 매핑 상세 조회
 */
export const getUrlMapping = <ThrowOnError extends boolean = false>(options: Options<GetUrlMappingData, ThrowOnError>): RequestResult<GetUrlMappingResponses, GetUrlMappingErrors, ThrowOnError> => (options.client ?? client).get<GetUrlMappingResponses, GetUrlMappingErrors, ThrowOnError>({ url: '/wello/v2/allows/url-mapping/{id}', ...options });

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushList = <ThrowOnError extends boolean = false>(options: Options<WelloAppPushListData, ThrowOnError>): RequestResult<WelloAppPushListResponses, WelloAppPushListErrors, ThrowOnError> => (options.client ?? client).get<WelloAppPushListResponses, WelloAppPushListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push', ...options });

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushRead = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushReadData, ThrowOnError>): RequestResult<UpdateWelloAppPushReadResponses, UpdateWelloAppPushReadErrors, ThrowOnError> => (options.client ?? client).put<UpdateWelloAppPushReadResponses, UpdateWelloAppPushReadErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-app-push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 앱 푸시 알림 건수 조회
 */
export const newWelloAppPushCnt = <ThrowOnError extends boolean = false>(options: Options<NewWelloAppPushCntData, ThrowOnError>): RequestResult<NewWelloAppPushCntResponses, NewWelloAppPushCntErrors, ThrowOnError> => (options.client ?? client).get<NewWelloAppPushCntResponses, NewWelloAppPushCntErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push/count', ...options });

/**
 * 웰로 앱 푸시(외부) 요청
 */
export const sendExtAppPush = <ThrowOnError extends boolean = false>(options: Options<SendExtAppPushData, ThrowOnError>): RequestResult<SendExtAppPushResponses, SendExtAppPushErrors, ThrowOnError> => (options.client ?? client).post<SendExtAppPushResponses, SendExtAppPushErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-app-push/ext',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 앱 푸시 트래킹&읽음 처리
 */
export const updateWelloAppPushRead1 = <ThrowOnError extends boolean = false>(options: Options<UpdateWelloAppPushRead1Data, ThrowOnError>): RequestResult<UpdateWelloAppPushRead1Responses, UpdateWelloAppPushRead1Errors, ThrowOnError> => (options.client ?? client).post<UpdateWelloAppPushRead1Responses, UpdateWelloAppPushRead1Errors, ThrowOnError>({ url: '/wello/v2/allows/wello-app-push/{welloAppPushReceiverId}', ...options });

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentList = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentListData, ThrowOnError>): RequestResult<GetMetaPolicyCommentListResponses, GetMetaPolicyCommentListErrors, ThrowOnError> => (options.client ?? client).get<GetMetaPolicyCommentListResponses, GetMetaPolicyCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment', ...options });

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentList = <ThrowOnError extends boolean = false>(options?: Options<GetLiveWelloCommentListData, ThrowOnError>): RequestResult<GetLiveWelloCommentListResponses, GetLiveWelloCommentListErrors, ThrowOnError> => (options?.client ?? client).get<GetLiveWelloCommentListResponses, GetLiveWelloCommentListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment/live', ...options });

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentList1 = <ThrowOnError extends boolean = false>(options: Options<GetMetaPolicyCommentList1Data, ThrowOnError>): RequestResult<GetMetaPolicyCommentList1Responses, GetMetaPolicyCommentList1Errors, ThrowOnError> => (options.client ?? client).get<GetMetaPolicyCommentList1Responses, GetMetaPolicyCommentList1Errors, ThrowOnError>({ url: '/wello/v2/allows/wello-comment/{welloCommentId}', ...options });

/**
 * 웰로 디바이스 정보 저장
 */
export const saveAllowsWelloDeviceInfo = <ThrowOnError extends boolean = false>(options: Options<SaveAllowsWelloDeviceInfoData, ThrowOnError>): RequestResult<SaveAllowsWelloDeviceInfoResponses, SaveAllowsWelloDeviceInfoErrors, ThrowOnError> => (options.client ?? client).post<SaveAllowsWelloDeviceInfoResponses, SaveAllowsWelloDeviceInfoErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-device-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 알림수신여부 조회
 *
 * 알림수신 여부를 조회합니다
 */
export const messageReceive = <ThrowOnError extends boolean = false>(options: Options<MessageReceiveData, ThrowOnError>): RequestResult<MessageReceiveResponses, MessageReceiveErrors, ThrowOnError> => (options.client ?? client).get<MessageReceiveResponses, MessageReceiveErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-device-info/message-receive', ...options });

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const updateMessageReceive = <ThrowOnError extends boolean = false>(options: Options<UpdateMessageReceiveData, ThrowOnError>): RequestResult<UpdateMessageReceiveResponses, UpdateMessageReceiveErrors, ThrowOnError> => (options.client ?? client).put<UpdateMessageReceiveResponses, UpdateMessageReceiveErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-device-info/message-receive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 비회원 대상지역 정보 저장
 */
export const saveWelloNonmemberRegion = <ThrowOnError extends boolean = false>(options: Options<SaveWelloNonmemberRegionData, ThrowOnError>): RequestResult<SaveWelloNonmemberRegionResponses, SaveWelloNonmemberRegionErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloNonmemberRegionResponses, SaveWelloNonmemberRegionErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-nonmember-region',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 웰로 정책 코드 목록
 */
export const welloPolicyCodeList = <ThrowOnError extends boolean = false>(options: Options<WelloPolicyCodeListData, ThrowOnError>): RequestResult<WelloPolicyCodeListResponses, WelloPolicyCodeListErrors, ThrowOnError> => (options.client ?? client).get<WelloPolicyCodeListResponses, WelloPolicyCodeListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code', ...options });

/**
 * 웰로 정책 코드 전체 목록
 */
export const welloPolicyCodeAllList = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeAllListData, ThrowOnError>): RequestResult<WelloPolicyCodeAllListResponses, WelloPolicyCodeAllListErrors, ThrowOnError> => (options?.client ?? client).get<WelloPolicyCodeAllListResponses, WelloPolicyCodeAllListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/all', ...options });

/**
 * 웰로 정책 코드 육아생활 목록
 */
export const welloPolicyCodeBabyList = <ThrowOnError extends boolean = false>(options?: Options<WelloPolicyCodeBabyListData, ThrowOnError>): RequestResult<WelloPolicyCodeBabyListResponses, WelloPolicyCodeBabyListErrors, ThrowOnError> => (options?.client ?? client).get<WelloPolicyCodeBabyListResponses, WelloPolicyCodeBabyListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/baby', ...options });

/**
 * KB 정책 코드 목록
 */
export const kbWelloPolicyCodeAllList = <ThrowOnError extends boolean = false>(options?: Options<KbWelloPolicyCodeAllListData, ThrowOnError>): RequestResult<KbWelloPolicyCodeAllListResponses, KbWelloPolicyCodeAllListErrors, ThrowOnError> => (options?.client ?? client).get<KbWelloPolicyCodeAllListResponses, KbWelloPolicyCodeAllListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/kb', ...options });

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const reverseGeocoding = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodingData, ThrowOnError>): RequestResult<ReverseGeocodingResponses, ReverseGeocodingErrors, ThrowOnError> => (options.client ?? client).get<ReverseGeocodingResponses, ReverseGeocodingErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-policy-code/reverse-geocoding', ...options });

/**
 * 웰로 퀵 메뉴 목록 조회
 *
 * 웰로 메인 상단 퀵 메뉴 목록을 조회합니다
 */
export const getWelloQuickMenuList = <ThrowOnError extends boolean = false>(options?: Options<GetWelloQuickMenuListData, ThrowOnError>): RequestResult<GetWelloQuickMenuListResponses, GetWelloQuickMenuListErrors, ThrowOnError> => (options?.client ?? client).get<GetWelloQuickMenuListResponses, GetWelloQuickMenuListErrors, ThrowOnError>({ url: '/wello/v2/allows/wello-quick-menu', ...options });

/**
 * 웰로 비회원 트래킹 정보 저장
 */
export const saveWelloTracking = <ThrowOnError extends boolean = false>(options: Options<SaveWelloTrackingData, ThrowOnError>): RequestResult<SaveWelloTrackingResponses, SaveWelloTrackingErrors, ThrowOnError> => (options.client ?? client).post<SaveWelloTrackingResponses, SaveWelloTrackingErrors, ThrowOnError>({
    url: '/wello/v2/allows/wello-track',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * V3 KB PAY 회원 웰로 로그인 — 토큰 발급(신규 회원은 자동 생성)
 */
export const loginWelloWithKbPay = <ThrowOnError extends boolean = false>(options: Options<LoginWelloWithKbPayData, ThrowOnError>): RequestResult<LoginWelloWithKbPayResponses, LoginWelloWithKbPayErrors, ThrowOnError> => (options.client ?? client).post<LoginWelloWithKbPayResponses, LoginWelloWithKbPayErrors, ThrowOnError>({
    url: '/wello/v3/allows/kb-pay/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * V3 KB 연동 로그인 타입 목록
 */
export const getKbMemberLoginTypeList = <ThrowOnError extends boolean = false>(options: Options<GetKbMemberLoginTypeListData, ThrowOnError>): RequestResult<GetKbMemberLoginTypeListResponses, GetKbMemberLoginTypeListErrors, ThrowOnError> => (options.client ?? client).get<GetKbMemberLoginTypeListResponses, GetKbMemberLoginTypeListErrors, ThrowOnError>({ url: '/wello/v3/allows/member-oauth/kb-member-login-type', ...options });

/**
 * V3 SNS 로그인 — 기존 계정 토큰 발급, 신규는 가입 필요 신호(signupRequired)
 */
export const loginWelloSnsMember = <ThrowOnError extends boolean = false>(options: Options<LoginWelloSnsMemberData, ThrowOnError>): RequestResult<LoginWelloSnsMemberResponses, LoginWelloSnsMemberErrors, ThrowOnError> => (options.client ?? client).post<LoginWelloSnsMemberResponses, LoginWelloSnsMemberErrors, ThrowOnError>({
    url: '/wello/v3/allows/member-oauth/sns/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * V3 토큰 재발급
 */
export const snsRefreshToken = <ThrowOnError extends boolean = false>(options: Options<SnsRefreshTokenData, ThrowOnError>): RequestResult<SnsRefreshTokenResponses, SnsRefreshTokenErrors, ThrowOnError> => (options.client ?? client).get<SnsRefreshTokenResponses, SnsRefreshTokenErrors, ThrowOnError>({ url: '/wello/v3/allows/member-oauth/sns/refresh-token', ...options });

/**
 * 가입 완료(complete) — 계정 이관 + 토큰 발급
 *
 * 약관 필수동의 완료 후 가입을 확정한다. 신규면 계정 생성 + 토큰 발급, 동일 CI 기존 계정이면 계정통합 필요를 반환한다.
 */
export const complete = <ThrowOnError extends boolean = false>(options: Options<CompleteData, ThrowOnError>): RequestResult<CompleteResponses, CompleteErrors, ThrowOnError> => (options.client ?? client).post<CompleteResponses, CompleteErrors, ThrowOnError>({
    url: '/wello/v3/allows/signup/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 가입 임시저장 생성/재사용(init)
 *
 * SNS 인증 후 가입 임시저장을 생성(또는 1시간 내 재사용)하고 참조키(UUID)를 반환한다.
 */
export const init = <ThrowOnError extends boolean = false>(options: Options<InitData, ThrowOnError>): RequestResult<InitResponses, InitErrors, ThrowOnError> => (options.client ?? client).post<InitResponses, InitErrors, ThrowOnError>({
    url: '/wello/v3/allows/signup/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 가입 중 계정통합 — 기존 활성계정에 SNS 부착 + 로그인
 *
 * 가입 중 계정통합. <code>complete</code>가 동일인 활성계정 존재로 통합 필요를 반환한 뒤, 고객이 통합 팝업에서 동의하면 호출한다.
 * 기존(생존) 계정에 새 SNS 로그인수단을 부착하고 그 계정으로 로그인 토큰을 발급한다(신규 계정 미생성).
 */
export const integrate = <ThrowOnError extends boolean = false>(options: Options<IntegrateData, ThrowOnError>): RequestResult<IntegrateResponses, IntegrateErrors, ThrowOnError> => (options.client ?? client).post<IntegrateResponses, IntegrateErrors, ThrowOnError>({
    url: '/wello/v3/allows/signup/integrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 닉네임·약관동의 저장
 *
 * 닉네임·약관동의를 가입 임시저장에 반영한다(본인인증 전 단계).
 */
export const saveNicknameConsent = <ThrowOnError extends boolean = false>(options: Options<SaveNicknameConsentData, ThrowOnError>): RequestResult<SaveNicknameConsentResponses, SaveNicknameConsentErrors, ThrowOnError> => (options.client ?? client).post<SaveNicknameConsentResponses, SaveNicknameConsentErrors, ThrowOnError>({
    url: '/wello/v3/allows/signup/nickname-consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 가입 본인인증 반영(무세션)
 *
 * 무세션 본인인증(모바일OK/EZI-OK) 결과를 가입 임시저장에 반영한다.
 */
export const verify = <ThrowOnError extends boolean = false>(options: Options<VerifyData, ThrowOnError>): RequestResult<VerifyResponses, VerifyErrors, ThrowOnError> => (options.client ?? client).post<VerifyResponses, VerifyErrors, ThrowOnError>({
    url: '/wello/v3/allows/signup/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
